import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  X, Loader2, Send, Ticket, Coins, Gift, ArrowDownToLine, ArrowUpFromLine,
  Info, ShieldCheck, ExternalLink, RefreshCw, ListChecks,
  ChevronRight, Check, Wallet, Copy, CheckCircle2, Clock,
  AlertTriangle, ChevronDown, Search, Star, ArrowDown, ArrowRightLeft, ArrowLeft
} from 'lucide-react';
import { WalletValue, BbIcon, RobuxIcon, useAuth, BB_NAME, BB_CHIP } from '../context/AuthContext';
import axios from 'axios';
/* MM2 rayı — site cüzdanının yatırma/çekme paneli.
   ⚠️ Robux/Gamepass paneli buradan söküldü: dayandığı uçlar backend'de
   artık yok. Bırakılsaydı ölü değil BOZUK kod olurdu (404). */
import { Mm2DepositPanel } from './mm2/Mm2DepositPanel';
import { Mm2WithdrawPanel } from './mm2/Mm2WithdrawPanel';
/* 🔪 MM2'nin görsel kimliği TEK KAYNAKTAN. Modal daha önce yeşil bir daire
   içine "MM" yazarak kendi rozetini uyduruyordu. */
import { Mm2Logo, BackButton } from './mm2/Mm2Brand';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
/* ⚠️ KURULUM: npm i qrcode.react
   Kripto yatırma ekranı ödeme adresini QR olarak gösteriyor. Adresi
   üçüncü parti bir QR servisine göndermek, kullanıcının ödeme adresini
   dışarı sızdırmak olurdu; bu yüzden QR İSTEMCİDE üretiliyor. */
import { QRCodeSVG } from 'qrcode.react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;


// ==========================================
// TABS CONFIG (ikonlu)
// ==========================================
// ⚠️ Kripto AYRI BİR SEKME DEĞİL. Sekme = NE yaptığın (yatır / çek),
// yöntem = NASIL yaptığın (Roblox Gamepass / kripto). Beşinci bir sekme
// eklemek mobilde etiketleri tamamen gizletip anlamsız bir ikon sırası
// bırakıyordu.
const tabs = [
  { id: 'deposit',  label: 'Deposit',    icon: ArrowDownToLine },
  { id: 'withdraw', label: 'Withdraw',   icon: ArrowUpFromLine },
  // 🍀 İki cüzdan arası dönüşüm — kullanıcının site parasını BB Coin'e
  // (ve tersine) çevirebildiği TEK yer.
  { id: 'convert',  label: 'Convert',    icon: ArrowRightLeft },
  { id: 'tip',      label: 'Tip',        icon: Coins },
  { id: 'promo',    label: 'Promo Code', icon: Gift }
];

// Tab başına aktif renkleri (mevcut palet korunuyor)
const TAB_COLORS = {
  deposit:  { active: 'bg-[#7b2fc4] text-white' },
  withdraw: { active: 'bg-[#15913f] text-white' },
  convert:  { active: 'bg-[#c98a00] text-white' },
  tip:      { active: 'bg-amber-600 text-white' },
  promo:    { active: 'bg-rose-600 text-white' }
};

// ==========================================
// K, M, B (Harf -> Sayı Çevirici) — tip miktarı için
// ==========================================
const parseAmount = (valStr) => {
  const v = parseAmountFloat(valStr);
  return Number.isFinite(v) ? Math.floor(v) : 0;
};

/* K/M/B ekini çözer ama YUVARLAMAZ — ondalık korunur.
   ⚠️ `parseAmount` sonucu `Math.floor`'ladığı için BB tarafında
   kullanılamaz: 23.457 BB = 23.457 mili-BB'dir, floor onu 23'e indirip
   tutarın %99,9'unu yok eder. Ölçek çevriminden ÖNCE yuvarlamak,
   birim dönüşümlerinde en sık yapılan hatadır. */
const parseAmountFloat = (valStr) => {
  if (!valStr) return 0;
  let str = valStr.toString().trim().toLowerCase();
  let multiplier = 1;
  if (str.endsWith('k')) { multiplier = 1000; str = str.slice(0, -1); }
  else if (str.endsWith('m')) { multiplier = 1000000; str = str.slice(0, -1); }
  else if (str.endsWith('b')) { multiplier = 1000000000; str = str.slice(0, -1); }
  const parsedValue = parseFloat(str);
  if (isNaN(parsedValue)) return 0;
  return parsedValue * multiplier;
};

// Ondalık girişi: . sonrası max 1 hane + opsiyonel tek K/M/B
const sanitizeAmountInput = (raw) => {
  if (raw == null) return '';
  let s = String(raw);
  const suffixMatch = s.match(/[kmbKMB]$/);
  const suffix = suffixMatch ? suffixMatch[0] : '';
  let num = suffix ? s.slice(0, -1) : s;
  num = num.replace(/[^0-9.]/g, '');
  const dot = num.indexOf('.');
  if (dot !== -1) {
    const intPart = num.slice(0, dot);
    const fracPart = num.slice(dot + 1).replace(/\./g, '').slice(0, 1);
    num = intPart + '.' + fracPart;
  }
  return num + suffix;
};

/* ⚠️ USD girişi AYRI bir temizleyici ister. `sanitizeAmountInput`
   ondalığı TEK haneye indiriyor — site parası için doğru, dolar için
   yanlış: kullanıcı "12.50" yazamıyor, "12.5"e düşüyordu. Sent
   hassasiyeti kripto tarafında gerçek para demek. */
const sanitizeUsdInput = (raw) => {
  if (raw == null) return '';
  let num = String(raw).replace(/[^0-9.]/g, '');
  const dot = num.indexOf('.');
  if (dot !== -1) {
    const intPart = num.slice(0, dot);
    const fracPart = num.slice(dot + 1).replace(/\./g, '').slice(0, 2);
    num = intPart + '.' + fracPart;
  }
  return num;
};

// ══════════════════════════════════════════════════════════════════════
// ══                        KRİPTO KATMANI                            ══
// ══════════════════════════════════════════════════════════════════════
/*
  Arka uç sözleşmesi (server.py'nin sunması gereken uçlar):

    GET  /api/game/crypto/config
         → { enabled, deposit_usd_per_1k, withdraw_usd_per_1k,
             min_deposit_usd, max_deposit_usd,
             min_withdraw_amount, max_withdraw_amount,
             withdraw_fee_percent, withdrawals_available,
             withdraw_unavailable_reason, assets: [...] }
      assets[]: { code, label, network, needs_memo, price_usd, available,
                  min_deposit_usd_coin, asset_min_withdraw_usd }

    POST /api/game/crypto/deposit          { asset, usd_amount | site_amount }
    GET  /api/game/crypto/deposit/active
    POST /api/game/crypto/deposit/cancel
    POST /api/game/crypto/withdraw/preview { asset, amount, address, extra_id }
    POST /api/game/crypto/withdraw         { asset, amount, address, extra_id }
    GET  /api/game/crypto/history

  ⚠️ ÖLÇEK: ORAN 1.000 BİRİM BAŞINA — `usd_per_1k`.
  server.py'nin kripto katmanı Decimal tabanını `_UNIT = 1_000` olarak
  kuruyor; kaynak sitedeki `usd_per_1m` (1.000.000 başına) DEĞİL. Bu
  bilinçli: burada bakiyeler Robux mertebesinde (P2P min deposit 10,
  min withdraw 50), milyarlar mertebesinde değil.

  Bu dosyadaki `usdToSite` / `siteToUsd` çarpanı bu yüzden 1e3'tür.
  1e6 kullanmak oranı 1000 kat kaydırır ve `deposit_usd_per_1m`
  okumak `undefined` → 0 verir; oran 0 olunca da limitler 0 çıkar ve
  arayüz "min 0 · max 0" gösterir.

  ⚠️ İKİ AYRI KOMİSYONU KARIŞTIRMA.
  Robux çekiminde kesilen %30 Roblox'un pazar yeri komisyonudur
  (fee_numerator/fee_denominator). Kripto çekimindeki kesinti
  `withdraw_fee_percent`'tir ve tamamen ayrıdır. Aynı ekranda ikisini
  aynı isimle göstermek kullanıcıya yalan söylemek olur.

  ⚠️ Gamepass yatırmadaki `bonus_bp` bonusu kripto yatırmaya UYGULANMAZ:
  o bonus Robux akışına özeldir. Kripto tarafında kullanıcının alacağı
  bakiye tamamen orandan gelir.
*/

/* Site parasının adı. Marka koda gömülmez; ayarlanmazsa marka-bağımsız
   "balance" kullanılır — yani yanlış marka adı gösterme riski yok. */
/* Site parasının GÖRÜNEN adı. Bu sitede site bakiyesi Robux rayında
   çalışıyor ve kullanıcı onu "MM Coin" olarak tanıyor; .env ile
   geçersiz kılınabilir ama varsayılan artık marka-nötr "balance" değil.
   ⚠️ Tanımlayıcı hâlâ 'main' — bu yalnızca etikettir. */
const SITE_BRAND = (process.env.REACT_APP_SITE_CURRENCY || 'MM Coin').trim();
const SITE_CUR = SITE_BRAND;                      // "MM Coin"
const SITE_CUR_CHIP = (SITE_BRAND || 'MMC');      // "MM Coin"

/* ══════════════════════════════════════════════════════════════════════
   🪙 KRİPTO RAYI ARTIK BB COIN CÜZDANINA BAĞLI
   ══════════════════════════════════════════════════════════════════════
   İkinci cüzdanın varlık sebebi bu: kripto GERÇEK PARADIR ve 1:1 geri
   ödenebilmesi gerekir. Site parası promo/rakeback/rain ile bedava
   üretiliyor; kripto oraya yazılsaydı "hangi bakiye gerçekten ödenebilir?"
   sorusunun cevabı kalmazdı.

   ⚠️ BİRİM: backend `lc_balance_milli` alanında MİLİ-LC tutar (1 LC = 1.000).
   Kripto uçlarının amount / min_withdraw_amount / site_amount alanlarının
   hepsi artık bu birimdedir. Ham sayıyı basmak BİN KAT şişik gösterir. */
const LC_MILLI = 1000;
// ⚠️ GÖRÜNEN AD TEK KAYNAKTAN (AuthContext). Burada literal yazmak, marka
// değişince iki yerin sessizce ayrışmasına yol açardı.
const LC_CUR = BB_NAME;        // "BB Coin"
const LC_CUR_CHIP = BB_CHIP;   // "BB"
/* Girdi (BB) → saklama birimi (mili-BB). Kullanıcı ekranda gördüğü
   rakamı yazar; çevirme burada, tek yerde olur.
   ⚠️ Kesir kabul edilir (0.5 BB = 500 mili-BB) ama aşağı yuvarlanır:
   yukarı yuvarlamak, kullanıcının sahip olmadığı bir tutarı göndermeye
   çalışması demek olurdu. */
/* BB girdi temizleyicisi — 3 ondalık, çünkü saklama hassasiyeti bu:
   1 mili-BB = 0.001 BB. Daha fazlasına izin vermek, yazılan rakamın
   aşağı yuvarlanıp kullanıcıyı şaşırtması demek olurdu. */
const sanitizeBbInput = (raw) => {
  if (raw == null) return '';
  let num = String(raw).replace(/[^0-9.]/g, '');
  const dot = num.indexOf('.');
  if (dot !== -1) {
    num = num.slice(0, dot) + '.' + num.slice(dot + 1).replace(/\./g, '').slice(0, 3);
  }
  return num;
};

const bbToMilli = (v) => {
  const x = parseFloat(String(v).replace(/[^0-9.]/g, ''));
  if (!(Number.isFinite(x) && x > 0)) return 0;
  /* ⚠️ EPSİLON ŞART. `23.457 * 1000` JavaScript'te 23456.999999999996
     verir; ham `Math.floor` bunu 23456'ya indirir ve kullanıcı yazdığından
     1 mili-BB eksik gönderir. Hata küçük ama SESSİZ: kimse fark etmez,
     bakiye zamanla aşağı kayar. */
  return Math.floor(x * LC_MILLI + 1e-6);
};

/* ══════════════════════════════════════════════════════════════════
   TIP TUTARI → SUNUCUNUN BEKLEDİĞİ BİRİM
   ══════════════════════════════════════════════════════════════════
   🔴 KAPATILAN HATA: Tip sekmesi tutarı `parseAmount` ile çözüp HAM
   sayıyı gönderiyordu. Site parası için doğru; ama BB Coin tarafında
   sunucu MİLİ-BB bekliyor (`lc_balance_milli`, 1 BB = 1.000).
   Sonuç: kullanıcı "23000" yazınca 23.000 mili-BB = **23 BB** gidiyor,
   sunucu da haklı olarak "100 BB – 100.000 BB arasında olmalı" diyordu.
   Yazılan rakamla gönderilen rakam 1000 kat ayrışıyordu.

   Çevrim TEK YERDE yapılır; `handleTip` artık kendi başına ölçek
   hesaplamaz. Aynı hatanın site parasında da olmadığını garantilemek
   için iki cüzdan da buradan geçer. */
const tipAmountToUnits = (valStr, isLcWallet) => {
  const v = parseAmountFloat(valStr);
  if (!Number.isFinite(v) || v <= 0) return 0;
  // BB: kullanıcı BB yazar, sunucu mili-BB ister (×1000, epsilon korumalı).
  // Site parası: zaten tam sayı birimidir, ölçek yok.
  return isLcWallet ? Math.floor(v * LC_MILLI + 1e-6) : Math.floor(v);
};

/* Girdi temizleyici de cüzdana göre değişmeli:
   BB'de 3 ondalık anlamlıdır (1 mili-BB = 0,001 BB), site parasında
   ondalık YOKTUR. Tek bir temizleyici kullanmak, BB'de "23.457" yazan
   kullanıcının son iki hanesinin sessizce silinmesine yol açıyordu
   (`sanitizeAmountInput` ondalığı TEK haneye kırpıyor). */
const sanitizeTipInput = (raw, isLcWallet) =>
  (isLcWallet ? sanitizeBbInput(raw) : sanitizeAmountInput(raw));
/* Saklama birimi (mili-BB) → girdi kutusuna yazılacak BB metni. */
/* Kutuya yazılacak değer — GÖSTERİMLE AYNI olmalı.
   ⚠️ Ekranda "1,457 BB" yazıp Max butonuna basınca kutuya "1457.545"
   düşseydi kullanıcı iki farklı rakam görürdü. Aşağı yuvarlıyoruz;
   geriye kalan 1 BB'nin altındaki toz (~$0.001) cüzdanda kalır. */
const milliToBbInput = (milli) => {
  const v = Math.floor(Number(milli) / LC_MILLI);
  if (!Number.isFinite(v) || v <= 0) return '';
  return String(v);
};
/* Alt sınırlar için YUKARI yuvarlama.
   ⚠️ Minimumu aşağı yuvarlamak TEHLİKELİ: gerçek min 5.010,5 BB iken
   ekranda "5.010" yazsaydı, kullanıcı tam o rakamı girip reddedilirdi
   ve sebebini anlayamazdı. */
const milliToBbInputCeil = (milli) => {
  const v = Math.ceil(Number(milli) / LC_MILLI);
  if (!Number.isFinite(v) || v <= 0) return '';
  return String(v);
};

/* ⚠️ ONDALIK GÖSTERİLMEZ (bkz. AuthContext.formatLc). Aşağı yuvarlanır. */
const fmtLc = (milli) => {
  const m = Number(milli);
  if (!Number.isFinite(m)) return '0';
  return Math.floor(m / LC_MILLI).toLocaleString('en-US');
};
/* Alt sınır gösterimi — yukarı yuvarlanır. */
const fmtLcCeil = (milli) => {
  const m = Number(milli);
  if (!Number.isFinite(m)) return '0';
  return Math.ceil(m / LC_MILLI).toLocaleString('en-US');
};

/* Oranın referans büyüklüğü: server.py'deki `_UNIT = Decimal(1_000)`
   ile AYNI olmak ZORUNDA. Burayı 1e6 yapıp arka ucu 1e3'te bırakmak
   (ya da tersi) her tutarı 1000 kat kaydırır ve hata hiçbir yerde
   patlamaz — sadece yanlış rakam gösterilir. */
const RATE_UNIT = 1000;

/* Kripto paneli mevcut paletin AYNISINI kullanır: kullanıcının ne
   yaptığı (yatır/çek) değişmiyor, yalnızca hangi rayı kullandığı. */
const CRYPTO_THEME = {
  deposit: {
    accent: '#B059E8', accentSoft: '#c98bf0',
    btn: 'from-[#7b2fc4] to-[#B059E8] hover:from-[#B059E8] hover:to-[#c98bf0]',
    ring: 'focus:border-[#B059E8]'
  },
  withdraw: {
    accent: '#16A34A', accentSoft: '#2ecf6e',
    btn: 'from-[#15913f] to-[#16A34A] hover:from-[#16A34A] hover:to-[#22c55e]',
    ring: 'focus:border-[#16A34A]'
  }
};

/* ── Tutar biçimleme ──────────────────────────────────────
   Modalın geri kalanı `toLocaleString` kullanıyor; kripto paneli de
   aynı dili konuşmalı ki kullanıcı iki farklı sayı biçimi arasında
   çeviri yapmak zorunda kalmasın. */
/* ⚠️ AŞAĞI yuvarlanır, Math.round DEĞİL: 999,7 → "1.000" göstermek
   kullanıcıya sahip olmadığı bir tutarı göstermek olurdu ve o rakamı
   girdiğinde reddedilirdi. */
const fmtBal = (n) => Math.floor(Number(n) || 0).toLocaleString('en-US');

const fmtCrypto = (n, decimals = 8) => {
  if (n == null || !Number.isFinite(Number(n))) return '—';
  return Number(n).toFixed(decimals).replace(/\.?0+$/, '');
};

const fmtPrice = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return null;
  if (n >= 1000) return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 });
  if (n >= 1) return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 2 });
  if (n >= 0.01) return '$' + n.toFixed(3);
  return '$' + n.toPrecision(2);
};

const mmss = (s) => {
  if (s < 0) s = 0;
  const m = Math.floor(s / 60), sec = s % 60;
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
};

/* "TRC-20 (Tron)" → "TRC-20" */
const shortNet = (n) => String(n || '').split('(')[0].trim();

/* ── Dönüşüm (yalnızca ÖNİZLEME) ──────────────────────────
   Bağlayıcı hesap sunucuda yapılır; burada amaç kullanıcının ne
   alacağını yazarken görmesi. Yön farkı bilinçli: üst sınırlar aşağı,
   alt sınırlar YUKARI yuvarlanır — aksi halde tam minimumda girilen
   tutar bir tık altına düşüp her seferinde reddedilir. */
const usdToSite = (usd, rate) =>
  (rate > 0 ? Math.floor((Number(usd) / rate) * RATE_UNIT) : 0);
const usdToSiteCeil = (usd, rate) =>
  (rate > 0 ? Math.ceil((Number(usd) / rate) * RATE_UNIT) : 0);
const siteToUsd = (site, rate) =>
  (rate > 0 ? (Number(site) / RATE_UNIT) * rate : 0);

/* Hazır tutar butonları için "yuvarlak" sayı: 43.712 → 43.000 */
const niceRound = (v) => {
  v = Math.floor(Number(v) || 0);
  if (v <= 0) return 0;
  if (v < 100) return v;
  const mag = Math.pow(10, String(v).length - 2);
  return Math.floor(v / mag) * mag;
};

/* ── Kopyala ──────────────────────────────────────────────── */
const CopyField = ({ label, value, accent, mono = true }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch { toast.error('Copy failed — select the text manually.'); }
  };
  return (
    <div className="space-y-1.5">
      <label className="text-[11px] uppercase tracking-wider text-zinc-500 font-bold">{label}</label>
      <button
        onClick={copy}
        className="w-full flex items-center gap-3 p-3 bg-[#15171a] border border-[#2A2D31] hover:border-zinc-600 rounded-xl text-left transition-colors group"
      >
        <span className={`flex-1 break-all text-sm text-white ${mono ? 'mm-num' : ''}`}>{value}</span>
        {copied
          ? <CheckCircle2 className="w-4 h-4 shrink-0" style={{ color: accent }} />
          : <Copy className="w-4 h-4 shrink-0 text-zinc-500 group-hover:text-zinc-300" />}
      </button>
    </div>
  );
};

/* ── Coin görselleri ────────────────────────────────────────
   İkon seti: cryptocurrency-icons (MIT) — jsDelivr üzerinden.
   Yüklenemezse marka renkli daire + kısaltmaya düşer, UI hiç bozulmaz. */
const COIN_META = {
  usdttrc20: { icon: 'usdt', color: '#26A17B', sym: 'USDT' },
  usdterc20: { icon: 'usdt', color: '#26A17B', sym: 'USDT' },
  usdtbsc:   { icon: 'usdt', color: '#26A17B', sym: 'USDT' },
  usdcsol:   { icon: 'usdc', color: '#2775CA', sym: 'USDC' },
  btc:       { icon: 'btc',  color: '#F7931A', sym: 'BTC'  },
  eth:       { icon: 'eth',  color: '#627EEA', sym: 'ETH'  },
  ltc:       { icon: 'ltc',  color: '#345D9D', sym: 'LTC'  },
  trx:       { icon: 'trx',  color: '#EB0029', sym: 'TRX'  },
  sol:       { icon: 'sol',  color: '#14F195', sym: 'SOL'  },
  doge:      { icon: 'doge', color: '#C2A633', sym: 'DOGE' },
  bnbbsc:    { icon: 'bnb',  color: '#F3BA2F', sym: 'BNB'  },
  xrp:       { icon: 'xrp',  color: '#4A5560', sym: 'XRP'  },
  ton:       { icon: 'ton',  color: '#0098EA', sym: 'TON'  },
  bch:       { icon: 'bch',  color: '#8DC351', sym: 'BCH'  },
};
const ICON_CDN = 'https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/svg/color';

const CoinIcon = ({ code, size = 32 }) => {
  const meta = COIN_META[code] || { color: '#52525b', sym: (code || '?').slice(0, 3).toUpperCase() };
  const [failed, setFailed] = useState(false);
  if (failed || !meta.icon) {
    return (
      <div
        className="rounded-full flex items-center justify-center shrink-0 font-bold text-white"
        style={{ width: size, height: size, background: meta.color, fontSize: size * 0.3 }}
      >
        {meta.sym.slice(0, 3)}
      </div>
    );
  }
  return (
    <img
      src={`${ICON_CDN}/${meta.icon}.svg`}
      alt={meta.sym}
      width={size} height={size}
      onError={() => setFailed(true)}
      className="rounded-full shrink-0"
      style={{ width: size, height: size }}
    />
  );
};

/* ── ÖNERİLEN COINLER ────────────────────────────────────────
   Ölçüt: ağ ücreti EN DÜŞÜK + onay süresi EN KISA + memo
   GEREKTİRMEYEN (yanlış memo = kayıp para).
     · LTC        ~2.5 dk blok, ücret sent mertebesinde, memo yok → varsayılan
     · USDT-TRC20 değer sabit (volatilite yok), TRON ücreti düşük
     · TRX        neredeyse anlık, ücret sıfıra yakın
   BTC ve ETH bilerek DIŞARIDA: en çok tutulan coinler olsalar da ağ
   ücretleri küçük yatırmaları ekonomik olmaktan çıkarıyor. Listede
   duruyorlar, sadece "önerilen" değiller. */
const RECOMMENDED = {
  ltc:       { rank: 1, why: 'Fast · lowest fees' },
  usdttrc20: { rank: 2, why: 'Stable value · low fees' },
  trx:       { rank: 3, why: 'Instant · near-zero fees' },
};
const isRec = (code) => Boolean(RECOMMENDED[code]);

/* Varsayılan coin: LTC. Devre dışıysa en yüksek sıralamalı önerilene,
   o da yoksa listenin ilkine düşer. */
const pickDefaultAsset = (list) => {
  if (!list || !list.length) return null;
  return list.find(a => a.code === 'ltc')
      || list.slice().sort((a, b) => (RECOMMENDED[a.code]?.rank || 99)
                                   - (RECOMMENDED[b.code]?.rank || 99))[0]
      || list[0];
};

const RecBadge = ({ accent, compact = false }) => (
  <span
    className={`inline-flex items-center gap-1 rounded font-bold uppercase tracking-wider
                shrink-0 ${compact ? 'text-[8px] px-1 py-px' : 'text-[9px] px-1.5 py-0.5'}`}
    style={{ background: `${accent}1f`, color: accent }}
  >
    <Star className={compact ? 'w-2 h-2' : 'w-2.5 h-2.5'} fill="currentColor" />
    {compact ? 'Rec' : 'Recommended'}
  </span>
);

const UnitChip = ({ children, tone = 'neutral', accent }) => (
  <span
    className="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded shrink-0"
    style={tone === 'accent'
      ? { background: `${accent}22`, color: accent }
      : { background: '#232629', color: '#a1a1aa' }}
  >
    {children}
  </span>
);

/* ── Aranabilir coin seçici ────────────────────────────────
   14 coin'i grid olarak listelemek formu ekrandan taşırıyordu.
   Tek satırlık seçici + arama. */
const CoinSelect = ({ assets, value, onChange, accent, mode, header }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const box = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    const base = s
      ? assets.filter(a => `${a.label} ${a.network} ${a.code}`.toLowerCase().includes(s))
      : assets;
    // Önerilenler her zaman ÜSTTE ve kendi aralarında sıralanmış.
    return base.slice().sort((a, b) => {
      const ra = RECOMMENDED[a.code]?.rank || 99;
      const rb = RECOMMENDED[b.code]?.rank || 99;
      return ra - rb;
    });
  }, [assets, q]);

  const recCount = list.filter(a => isRec(a.code)).length;

  const minFor = (a) => (mode === 'deposit'
    ? Number(a.min_deposit_usd_coin || 0)
    : Number(a.asset_min_withdraw_usd || 0));

  return (
    <div className="space-y-2" ref={box}>
      {/* ⚠️ "Coin & network" ETİKETİ BURADAN ÇIKTI. Panelin en üstünde ayrı
          bir satır olarak duruyordu; hemen üstünde de geri butonunun kendi
          satırı vardı. İki satır, ikisi de neredeyse boş. Etiket artık
          `header` olarak dışarıdan geliyor ve geri butonuyla AYNI satırı
          paylaşıyor — MM2 panellerindeki düzenin aynısı. */}
      {header}

      <button
        type="button"
        onClick={() => { setOpen(o => !o); setQ(''); }}
        className="w-full flex items-center gap-3 p-3 rounded-xl border transition-colors text-left"
        style={{ borderColor: open ? accent : '#2A2D31', background: '#15171a' }}
      >
        {value ? (
          <>
            <CoinIcon code={value.code} size={34} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold text-white leading-tight truncate flex items-center gap-2">
                <span className="truncate">{value.label}</span>
                <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-[#232629] text-zinc-400 shrink-0">
                  {shortNet(value.network)}
                </span>
                {isRec(value.code) && <RecBadge accent={accent} compact />}
              </p>
              <p className="text-[11px] leading-tight mt-0.5 truncate">
                {isRec(value.code)
                  ? <span style={{ color: accent }}>{RECOMMENDED[value.code].why}</span>
                  : <span className="text-zinc-500 mm-num">{fmtPrice(value.price_usd) || ''}</span>}
              </p>
            </div>
          </>
        ) : (
          <span className="flex-1 text-sm text-zinc-500">Select a coin</span>
        )}
        <ChevronDown className={`w-4 h-4 text-zinc-500 shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.12 }}
            className="relative z-30"
          >
            <div className="absolute left-0 right-0 rounded-xl border border-[#2A2D31] bg-[#15171a] shadow-2xl overflow-hidden">
              {assets.length > 6 && (
                <div className="flex items-center gap-2 px-3 py-2 border-b border-[#2A2D31]">
                  <Search className="w-3.5 h-3.5 text-zinc-600 shrink-0" />
                  <input
                    autoFocus value={q} onChange={e => setQ(e.target.value)}
                    placeholder="Search coin or network"
                    className="flex-1 bg-transparent text-sm text-white outline-none placeholder:text-zinc-600"
                  />
                </div>
              )}
              <div className="max-h-[min(46vh,300px)] overflow-y-auto overscroll-contain">
                {list.length === 0 && (
                  <p className="px-3 py-6 text-center text-xs text-zinc-600">No match</p>
                )}
                {list.map((a, i) => {
                  const active = value?.code === a.code;
                  const m = minFor(a);
                  const rec = isRec(a.code);
                  return (
                    <React.Fragment key={a.code}>
                      {i === 0 && rec && (
                        <p className="px-3 pt-2 pb-1 text-[9px] font-bold uppercase tracking-wider"
                           style={{ color: accent }}>
                          Recommended
                        </p>
                      )}
                      {i === recCount && recCount > 0 && (
                        <p className="px-3 pt-2.5 pb-1 text-[9px] font-bold uppercase tracking-wider text-zinc-600 border-t border-[#2A2D31] mt-1">
                          All coins
                        </p>
                      )}
                      <button
                        type="button"
                        onClick={() => { onChange(a); setOpen(false); }}
                        className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-[#1d2023] transition-colors"
                        style={active ? { background: `${accent}14` } : {}}
                      >
                        <CoinIcon code={a.code} size={28} />
                        <div className="flex-1 min-w-0">
                          <p className="text-[13px] font-semibold text-white leading-tight truncate">
                            {a.label}
                            <span className="ml-1.5 text-[10px] text-zinc-500 font-normal">
                              {shortNet(a.network)}
                            </span>
                          </p>
                          <p className="text-[10px] leading-tight mt-0.5 truncate">
                            {rec
                              ? <span style={{ color: accent }}>{RECOMMENDED[a.code].why}</span>
                              : (m > 0
                                  ? <span className="text-zinc-600">min ${m.toFixed(2)}</span>
                                  : <span className="text-zinc-600">{shortNet(a.network)} network</span>)}
                          </p>
                        </div>
                        {fmtPrice(a.price_usd) && (
                          <span className="text-[11px] text-zinc-500 mm-num shrink-0">
                            {fmtPrice(a.price_usd)}
                          </span>
                        )}
                        {active && <Check className="w-4 h-4 shrink-0" style={{ color: accent }} />}
                      </button>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   KRİPTO PANELİ (deposit / withdraw)
   ═══════════════════════════════════════════════════════════ */
/* ══════════════════════════════════════════════════════════════════════
   🗑️ `WalletGate` BURADAN SİLİNDİ.
   ──────────────────────────────────────────────────────────────────────
   "Bu yöntem BB Coin'ini kullanıyor ama aktif cüzdanın farklı — geçiş
   yap" diye kehribar bir uyarı çizen bir bileşendi. İki sorunu vardı:

     1) HİÇBİR YERDE ÇAĞRILMIYORDU. Tanımlıydı, render edilmiyordu.
     2) DAHA KÖTÜSÜ, İDDİASI YANLIŞTI. Sökülen Robux P2P rayından
        kalmıştı; o rayda backend gerçekten cüzdan kilidi uyguluyordu.
        Bugünkü uçlar öyle değil: /game/crypto/deposit,
        /game/crypto/withdraw ve /game/mm2/* `active_wallet` alanına
        BAKMIYOR. Hangi cüzdanda olursan ol diğerine yatırıp diğerinden
        çekebilirsin.

   Bırakılsaydı, bir gün biri onu "kullanılmıyor ama herhalde gerekli"
   diye ekrana koyar ve kullanıcıya var olmayan bir kural dayatırdı.
   ══════════════════════════════════════════════════════════════════════ */

// ══════════════════════════════════════════════════════════════════════
// 🪙 CÜZDAN DÖNÜŞÜMÜ — SITE ⇄ BB COIN
// ══════════════════════════════════════════════════════════════════════
// Backend iki ayrı uç sunuyor ve ikisi FARKLI oran kullanır:
//   LC → site : /wallet/convert         (deposit oranı)
//   site → LC : /wallet/convert-to-lc   (withdraw oranı)
// Turun çarpanı bilerek 1'in ALTINDADIR (kasa payı); ileri-geri çevirerek
// para üretmek matematiksel olarak imkânsız. Arayüz bunu GİZLEMEZ —
// kullanıcı ne alacağını işlemden ÖNCE görür.
const ConvertPanel = () => {
  const { walletMeta, refreshWalletMeta, siteBalance, lcBalanceMilli, refreshUser } = useAuth();
  const [dir, setDir] = useState('lc_to_site');
  const [raw, setRaw] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => { refreshWalletMeta(); }, [refreshWalletMeta]);

  const cv = walletMeta?.convert;
  const enabled = !!cv?.enabled;
  const toSite = dir === 'lc_to_site';

  // Girdi birimi: LC→site yönünde kullanıcı LC yazar (mili-LC'ye çevrilir),
  // site→LC yönünde site birimi yazar.
  const amount = useMemo(() => {
    const v = parseFloat(String(raw).replace(',', '.'));
    if (!Number.isFinite(v) || v <= 0) return 0;
    return toSite ? Math.floor(v * LC_MILLI) : Math.floor(v);
  }, [raw, toSite]);

  const lo = toSite ? (cv?.lc_to_site?.min_milli ?? 0) : (cv?.site_to_lc?.min_site ?? 0);
  const hi = toSite ? (cv?.lc_to_site?.max_milli ?? 0) : (cv?.site_to_lc?.max_site ?? 0);
  const have = toSite ? lcBalanceMilli : siteBalance;

  // Beklenen çıktı — backend ile AYNI zincirden canlı hesaplanır.
  const preview = useMemo(() => {
    const r = walletMeta?.rates; if (!r || !amount) return 0;
    if (toSite) {
      const usd = amount / LC_MILLI / (r.lc_deposit_per_usd || 1);
      return Math.floor(usd / (r.site_deposit_usd_per_1m || 1) * 1000000);
    }
    const usd = amount / 1000000 * (r.site_withdraw_usd_per_1m || 0);
    return Math.floor(usd * (r.lc_deposit_per_usd || 0) * LC_MILLI);
  }, [amount, toSite, walletMeta]);

  const fmtIn  = (v) => toSite ? `${fmtLc(v)} ${LC_CUR_CHIP}` : `${fmtBal(v)} ${SITE_CUR_CHIP}`;
  const fmtOut = (v) => toSite ? `${fmtBal(v)} ${SITE_CUR_CHIP}` : `${fmtLc(v)} ${LC_CUR_CHIP}`;
  /* ⚠️ BİRİM ETİKETİ AYRI. Alınan tutar kutusunda birim zaten sağdaki
     hapta yazıyor; metnin sonundaki adı kırpmaya çalışmak ("MM Coin" iki
     kelime) sessizce yanlış sonuç verir. Sayıyı sayı olarak üreten ayrı
     bir biçimleyici tek doğru çözüm. */
  const numOut = (v) => toSite ? fmtBal(v) : fmtLc(v);

  const err = !amount ? null
    : amount > have ? `You only have ${fmtIn(have)}.`
    : (lo && amount < lo) ? `Minimum is ${fmtIn(lo)}.`
    : (hi && amount > hi) ? `Maximum is ${fmtIn(hi)} per transaction.`
    : preview <= 0 ? 'Amount is too small to convert at the current rate.'
    : null;

  const submit = async () => {
    if (busy || !amount || err || !enabled) return;
    setBusy(true);
    try {
      // ⚠️ idem_key: ağ tekrarında ÇİFT DÖNÜŞÜM olmaması için. Backend bunu
      // ad alanına alıp idempotans defterine yazıyor.
      const idem = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      const body = toSite ? { amount_micro: amount, idem_key: idem }
                          : { site_units: amount, idem_key: idem };
      const url = toSite ? `${API}/wallet/convert` : `${API}/wallet/convert-to-lc`;
      const { data } = await axios.post(url, body);
      toast.success(`Converted to ${toSite ? fmtBal(data.site_units) + ' ' + SITE_CUR_CHIP
                                           : fmtLc(data.lc_milli) + ' ' + LC_CUR_CHIP}`);
      setRaw('');
      await Promise.all([refreshUser(), refreshWalletMeta()]);
    } catch (e) {
      // 409 açık oyun · 429 günlük kota · 503 oran güvensiz/bakım · 403 donmuş
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Conversion failed.');
    } finally { setBusy(false); }
  };

  if (walletMeta && !enabled) {
    return (
      <div className="flex flex-col items-center text-center gap-3 py-10 px-6">
        <AlertTriangle className="w-10 h-10 text-amber-400" />
        <p className="text-white font-bold">Conversion is currently unavailable</p>
        <p className="text-zinc-400 text-sm max-w-xs">
          Wallet conversion is paused. Your balances are safe and unchanged.
        </p>
      </div>
    );
  }

  /* Hızlı tutar kısayolları. Kullanıcıların ezici çoğunluğu ya hepsini ya
     da yarısını çeviriyor; her seferinde rakam yazdırmak gereksiz sürtünme. */
  const setPortion = (frac) => {
    const v = toSite ? (have / LC_MILLI) * frac : Math.floor(have * frac);
    /* ⚠️ AŞAĞI yuvarlanır: yukarı yuvarlamak sahip olunmayan bir tutarı
       kutuya yazıp kullanıcıyı "yetersiz bakiye" hatasına sürüklerdi. */
    setRaw(toSite ? String(Math.floor(v * 1000) / 1000) : String(Math.floor(v)));
  };

  const FromIcon = toSite ? BbIcon : RobuxIcon;
  const ToIcon = toSite ? RobuxIcon : BbIcon;

  return (
    <div className="space-y-3">
      <header>
        <h3 className="font-heading font-bold text-white text-xl leading-tight">Convert</h3>
        <p className="text-[11px] text-zinc-500 mt-1">
          Move value between your two wallets at the live rate.
        </p>
      </header>

      {/* ══════════════════════════════════════════════════════════════════
          TAKAS KUTUSU
          ⚠️ İKİ AYRI YÖN BUTONU SÖKÜLDÜ. Kullanıcı "LC → MM" ve "MM → LC"
          yazan iki kutuyu okuyup karşılaştırmak zorunda kalıyordu. Yön
          artık kutuların KENDİSİNDE görünüyor ve ortadaki tek düğme onu
          ters çeviriyor — para değişimi arayüzlerinin standart deseni,
          çünkü öğrenilecek bir şey bırakmıyor.
          ══════════════════════════════════════════════════════════════════ */}
      <div className="relative">
        {/* GÖNDERİLEN */}
        <div className="mm-inset p-3.5">
          <div className="flex items-center justify-between mb-2">
            <span className="mm-eyebrow">You send</span>
            <div className="flex items-center gap-1">
              {[['25%', 0.25], ['50%', 0.5], ['Max', 1]].map(([label, f]) => (
                <button key={label} type="button" onClick={() => setPortion(f)}
                  className="mm-focus px-2 py-1 rounded-md text-[10px] font-bold text-zinc-400
                             hover:text-white hover:bg-white/[0.06] transition-colors">
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-3">
            <input value={raw} onChange={(e) => setRaw(e.target.value.replace(/[^0-9.,]/g, ''))}
              inputMode="decimal" placeholder="0" aria-label="Amount to convert"
              className="flex-1 bg-transparent text-white text-2xl mm-num font-bold outline-none min-w-0
                         placeholder:text-zinc-700" />
            <span className="flex items-center gap-1.5 shrink-0 px-2.5 py-1.5 rounded-lg bg-[#121417] border border-[#2A2D31]">
              <FromIcon size={16} />
              <span className="text-[11px] font-bold text-zinc-300">
                {toSite ? LC_CUR_CHIP : SITE_CUR_CHIP}
              </span>
            </span>
          </div>
          <p className="text-[10px] text-zinc-500 mt-2">Balance {fmtIn(have)}</p>
        </div>

        {/* YÖN DÜĞMESİ — iki kutunun tam ortasında, çakışarak duruyor.
            Çakışma bilinçli: ikisinin AYNI işlemin iki ucu olduğunu söyler. */}
        <div className="relative h-0 flex justify-center z-10">
          <button type="button" aria-label="Swap direction"
            onClick={() => { setDir(toSite ? 'site_to_lc' : 'lc_to_site'); setRaw(''); }}
            className="mm-focus absolute -top-[18px] w-9 h-9 rounded-full grid place-items-center
                       bg-[#1F2225] border border-[#3a3d43] text-zinc-400
                       hover:text-white hover:border-[#B059E8]/60 hover:rotate-180
                       transition-all duration-300">
            <ArrowDown className="w-4 h-4" />
          </button>
        </div>

        {/* ALINAN */}
        <div className="mm-inset p-3.5 mt-1.5">
          <span className="mm-eyebrow">You receive</span>
          <div className="flex items-center gap-3 mt-2">
            <p className={`flex-1 text-2xl mm-num font-bold min-w-0 truncate ${amount && preview > 0 ? 'text-[#2ecf6e]' : 'text-zinc-700'}`}>
              {amount ? numOut(preview) : '0'}
            </p>
            <span className="flex items-center gap-1.5 shrink-0 px-2.5 py-1.5 rounded-lg bg-[#121417] border border-[#2A2D31]">
              <ToIcon size={16} />
              <span className="text-[11px] font-bold text-zinc-300">
                {toSite ? SITE_CUR_CHIP : LC_CUR_CHIP}
              </span>
            </span>
          </div>
        </div>
      </div>

      {err && (
        <div className="flex items-start gap-2 rounded-lg bg-[#E5484D]/10 border border-[#E5484D]/25 px-3 py-2.5">
          <AlertTriangle className="w-3.5 h-3.5 text-[#E5484D] mt-0.5 shrink-0" />
          <span className="text-[11px] text-[#ff9b9e]">{err}</span>
        </div>
      )}

      <button type="button" disabled={busy || !amount || !!err} onClick={submit}
        className="mm-focus w-full py-3.5 rounded-xl bg-[#c98a00] hover:bg-[#b07a00]
                   disabled:opacity-40 disabled:cursor-not-allowed text-white
                   font-heading font-bold text-sm uppercase tracking-wider
                   transition-colors flex items-center justify-center gap-2">
        {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Converting…</> : 'Convert'}
      </button>

      {/* Kasa payı İŞLEMDEN ÖNCE görünür. Gizlemek, kullanıcının parası
          eksildiğinde güveni topluca kaybetmek demek. */}
      <p className="text-[10px] text-zinc-500 leading-relaxed">
        Rates are live. A small spread applies each way, so converting back and
        forth returns slightly less than you started with. Finish any open game first.
      </p>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════════════
   DÖNÜŞÜM KISAYOLU
   ══════════════════════════════════════════════════════════════════════
   ⚠️ ESKİDEN YALNIZCA YATIRMA EKRANINDA VARDI ve bu bir hataydı: bir
   cüzdanında parası olan kullanıcı "çekmek" isteyip diğer cüzdanı boş
   bulunca elinde seçenek kalmıyor, dönüşümün var olduğunu hiç
   öğrenmiyordu. Aynı kısayol artık YATIRMA ve ÇEKME köklerinde duruyor —
   tek bileşen, tek metin, iki yer. */
const ConvertShortcut = ({ onClick, root }) => (
  <button type="button" onClick={onClick} data-testid="convert-shortcut"
    className="mm-focus group w-full flex items-center gap-3 px-3.5 py-3 rounded-xl
               bg-[#141719] border border-[#2A2D31] hover:border-[#c98a00]/45 transition-colors">
    <span className="w-8 h-8 rounded-lg grid place-items-center shrink-0
                     bg-[#c98a00]/12 text-[#e0a520]">
      <ArrowRightLeft className="w-4 h-4" />
    </span>
    <span className="min-w-0 flex-1 text-left">
      <span className="block text-[12px] font-bold text-zinc-200 leading-tight">
        Convert between wallets
      </span>
      <span className="block text-[10px] text-zinc-500 mt-0.5">
        {root === 'withdraw'
          ? 'Cash out from the other wallet instead'
          : 'Already have a balance in the other wallet'}
      </span>
    </span>
    <ChevronRight className="w-4 h-4 text-zinc-600 group-hover:text-zinc-400 transition-colors shrink-0" />
  </button>
);

/* ⚠️ `balance` PROP'U ARTIK MİLİ-LC. Çağıran taraf user.balance (site
   parası) yerine user.lc_balance_milli geçmeli — yoksa kullanıcı site
   bakiyesiyle LC çekmeye çalışır ve limitler tamamen yanlış hesaplanır. */
const CryptoPanel = ({ mode = 'deposit', token, balance, onCredited, onBack }) => {
  const T = CRYPTO_THEME[mode];
  const auth = useMemo(() => ({ headers: { Authorization: `Bearer ${token}` } }), [token]);

  const [config, setConfig] = useState(null);
  const [loadingCfg, setLoadingCfg] = useState(true);
  /* ⚠️ "Kripto kapalı" ile "kripto ucu YOK" aynı ekrana düşüyordu.
     Kullanıcı için ikisi de kullanılamaz demek — ama kurulumu yapan için
     tamamen farklı iki sorun. Sebebi konsola yazıyoruz; ekranda teknik
     ayrıntı göstermek kullanıcının işine yaramaz. */
  const [cfgError, setCfgError] = useState(null);   // null | 'missing' | 'network'
  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(false);

  // deposit
  const [amountInput, setAmountInput] = useState('');
  const [inputMode, setInputMode] = useState('site');   // 'site' | 'usd'
  const [invoice, setInvoice] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0);
  const [depositDone, setDepositDone] = useState(null);

  // withdraw
  const [address, setAddress] = useState('');
  const [memo, setMemo] = useState('');
  const [submitted, setSubmitted] = useState(null);
  /* ⚠️ ADRES DOĞRULANABİLİRLİĞİ. Arka uç 'address_check' alanında adresin
     matematiksel checksum'ının doğrulanıp doğrulanamadığını bildiriyor
     ('ok' | 'unchecked'). Küçük harfli EVM ve Solana adreslerinde tek
     karakterlik yazım hatası YAKALANAMAZ ve fon geri dönüşü olmadan
     kaybolur; bu durumda açık onay istiyoruz. */
  const [addrCheck, setAddrCheck] = useState(null);     // null | 'ok' | 'unchecked' | 'skip'
  const [addrConfirmed, setAddrConfirmed] = useState(false);
  /* Çekim İKİ ADIM: 'amount' → 'address'. Geri alınamaz bir transferde
     adres girişinin tam dikkat alması doğru olan; kullanıcı tutarla
     uğraşırken adresi yanlış yapıştırmıyor. */
  const [wdStep, setWdStep] = useState('amount');

  /* ── Config yükle ── */
  const loadConfig = useCallback(async (silent = false) => {
    try {
      const { data } = await axios.get(`${API}/game/crypto/config`, auth);
      setConfig(data);
      // Seçili coin'i de tazele: aksi halde ekranda DONMUŞ fiyat kalırdı.
      setAsset(prev => {
        if (!data.assets?.length) return null;
        if (!prev) return pickDefaultAsset(data.assets);
        return data.assets.find(a => a.code === prev.code) || pickDefaultAsset(data.assets);
      });
      setCfgError(null);
    } catch (e) {
      if (!silent) {
        const st = e.response?.status;
        setConfig({ enabled: false, assets: [] });
        setCfgError(st === 404 ? 'missing' : 'network');
        console.warn(
          st === 404
            ? `[wallet] ${API}/game/crypto/config → 404. Kripto katmanı server.py'de `
              + `kayıtlı değil: setup_crypto(api_router, CryptoDeps(...)) çağrısı eksik.`
            : `[wallet] ${API}/game/crypto/config başarısız (${st || 'ağ hatası'}).`);
      }
    } finally { setLoadingCfg(false); }
  }, [auth]);

  useEffect(() => { loadConfig(); }, [loadConfig]);

  /* ── Canlı piyasa fiyatı: 30 sn'de bir sessiz tazeleme ── */
  useEffect(() => {
    if (!token) return;
    const t = setInterval(() => loadConfig(true), 30000);
    return () => clearInterval(t);
  }, [token, loadConfig]);

  /* ── Açık deposit varsa geri yükle ──
     ⚠️ ŞART: kullanıcı sayfayı yenilerse ödeme adresini kaybeder ve
     gönderdiği kriptoyu nereye yolladığını göremez. */
  useEffect(() => {
    if (mode !== 'deposit' || !token) return;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/game/crypto/deposit/active`, auth);
        if (data.has_active) {
          const tx = data.transaction;
          setInvoice({
            transaction_id: tx.id, asset: tx.asset, network: tx.network,
            pay_address: tx.pay_address, pay_amount: tx.pay_amount,
            extra_id: tx.extra_id, usd_amount: tx.expected_usd,
            site_amount: tx.amount, expires_at: tx.expires_at
          });
        }
      } catch { /* yoksay */ }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, token]);

  /* ── Geri sayım ── */
  useEffect(() => {
    if (!invoice?.expires_at) { setTimeLeft(0); return; }
    const tick = () => {
      setTimeLeft(Math.floor((new Date(invoice.expires_at).getTime() - Date.now()) / 1000));
    };
    tick();
    const i = setInterval(tick, 1000);
    return () => clearInterval(i);
  }, [invoice]);

  /* ── Ödeme bekleme yoklaması ──
     Kullanıcı "gönderdim" butonuna basmaz: zinciri BİZ izleriz. */
  useEffect(() => {
    if (!invoice?.transaction_id || depositDone) return;
    const poll = setInterval(async () => {
      try {
        const { data } = await axios.get(`${API}/game/crypto/history`, auth);
        const tx = (data || []).find(t => t.id === invoice.transaction_id);
        if (!tx) return;
        if (tx.status === 'completed') {
          setDepositDone(tx);
          setInvoice(null);
          toast.success(`Deposit credited: ${fmtLc(tx.amount)} ${LC_CUR_CHIP}`);
          if (onCredited) onCredited();
        } else if (['expired', 'failed'].includes(tx.status)) {
          /* ⚠️ "Süre doldu" TEK BAŞINA ZARARLI BİR MESAJ: parasını
             göndermiş kullanıcı, parasının yandığını sanır. Adres
             zincirde canlı, geç gelen transfer yine kredilenir. */
          setInvoice(null);
          toast.error('Deposit window closed. If you already sent funds, they will still be credited automatically.',
            { duration: 12000 });
        } else if (['cancelled', 'refunded'].includes(tx.status)) {
          setInvoice(null);
          toast.error('Deposit was cancelled.');
        } else if (tx.status === 'manual_review') {
          setInvoice(null);
          toast.warning('Your deposit is under review. Support will finish it shortly.',
            { duration: 12000 });
        }
      } catch { /* geçici ağ hatası — bir sonraki turda tekrar denenir */ }
    }, 8000);
    return () => clearInterval(poll);
  }, [invoice, depositDone, auth, onCredited]);

  /* ── Adres/memo/coin değişirse önceki onay GEÇERSİZ ──
     ⚠️ Bağımlılık `asset` DEĞİL `asset?.code`: 30 saniyelik fiyat
     tazelemesi asset nesnesinin kimliğini değiştiriyor, bu da adres
     onayını her yarım dakikada bir sıfırlardı. */
  useEffect(() => { setAddrCheck(null); setAddrConfirmed(false); },
            [address, memo, asset?.code]);
  // Coin değişince adres adımından çık: yanlış coine adres girilmesin.
  useEffect(() => { setWdStep('amount'); }, [mode, asset?.code]);

  /* ── Canlı dönüşüm önizlemesi ── */
  const preview = useMemo(() => {
    if (!config) return null;
    const raw = amountInput.trim();
    if (!raw) return null;

    if (mode === 'deposit') {
      const rate = Number(config.deposit_usd_per_1k) || 0;
      const px = Number(asset?.price_usd) || 0;
      if (inputMode === 'usd') {
        const usd = parseFloat(raw.replace(/[^0-9.]/g, '')) || 0;
        return { usd, site: usdToSite(usd, rate), crypto: px > 0 ? usd / px : null };
      }
      // ⚠️ Girdi BB cinsinden; saklama/oran matematiği mili-BB ile çalışır.
      const site = bbToMilli(raw);
      const usd = siteToUsd(site, rate);
      return { site, usd, crypto: px > 0 ? usd / px : null };
    }
    const rate = Number(config.withdraw_usd_per_1k) || 0;
    const site = bbToMilli(raw);
    const gross = siteToUsd(site, rate);
    const net = gross * (1 - (Number(config.withdraw_fee_percent) || 0) / 100);
    return { site, usd: net, gross, crypto: asset?.price_usd ? net / asset.price_usd : null };
  }, [amountInput, inputMode, config, mode, asset]);

  /* ══════════════════════════════════════════════════════════════
     LİMİTLER — TEK KAYNAK

     ⚠️ Önceki hali aynı sınırı İKİ AYRI YERDE, İKİ FARKLI SAYIYLA
     hesaplıyordu: ekranda gösterilen alt sınır coin bazlı ağ tabanını
     içeriyordu ama doğrulama ham `config.min_deposit_usd`'ye bakıyordu.
     Kullanıcı ekrandaki "Min" butonuna basıyor, tutar geçerli görünüyor,
     sonra ikinci bir hata mesajıyla reddediliyordu. Gösterim, hazır
     tutarlar, buton durumu ve doğrulama artık HEPSİ burayı okuyor.
     ══════════════════════════════════════════════════════════════ */
  const limits = useMemo(() => {
    if (!config) return null;
    const feePct = Math.min(50, Math.max(0, Number(config.withdraw_fee_percent) || 0));

    if (mode === 'deposit') {
      const rate = Number(config.deposit_usd_per_1k) || 0;
      /* Gateway site parasıyla değil USD ile çalışır → otorite USD tarafı.
         Coin bazlı taban ağ ücretiyle DEĞİŞİR; global minimumla karşılaştırılıp
         büyüğü alınır. */
      const coinFloorUsd = Number(asset?.min_deposit_usd_coin) || 0;
      const globalMinUsd = Number(config.min_deposit_usd) || 0;
      const minUsd = Math.max(globalMinUsd, coinFloorUsd);
      const maxUsd = Number(config.max_deposit_usd) || 0;
      return {
        rate, feePct, minUsd, maxUsd, globalMinUsd, coinFloorUsd,
        siteLo: usdToSiteCeil(minUsd, rate),
        siteHi: usdToSite(maxUsd, rate),
        capped: false,
        ok: rate > 0 && minUsd > 0 && maxUsd >= minUsd,
      };
    }

    const rate = Number(config.withdraw_usd_per_1k) || 0;
    /* ⚠️ KOMİSYON ALT SINIRI DA KAYDIRIR — buradaki hata sessizdi.
       Coin bazlı taban kullanıcının ELİNE GEÇEN (net) tutara uygulanıyor,
       site tutarı ise komisyon kesilmeden ÖNCEKİ brüt değer. Komisyonu
       hesaba katmadan çevirirsek ekranda gösterdiğimiz minimum KENDİ
       doğrulamamızdan geçemez: %5 komisyonda "min 400" yazıp tam 400
       girildiğinde net tutar tabanın altında kalıp reddediliyordu. */
    const coinFloorUsd = Number(asset?.asset_min_withdraw_usd) || 0;
    const grossFloorUsd = feePct > 0 ? coinFloorUsd / (1 - feePct / 100) : coinFloorUsd;
    const siteLo = Math.max(Number(config.min_withdraw_amount) || 0,
                            usdToSiteCeil(grossFloorUsd, rate));
    const cfgHi = Number(config.max_withdraw_amount) || 0;
    /* Bakiyeden fazlasını üst sınır diye göstermek, "Max"a basan kullanıcıyı
       doğrudan hataya sürüklemek olur. */
    const balHi = Number.isFinite(Number(balance)) ? Math.floor(Number(balance)) : null;
    const capped = balHi != null && balHi < cfgHi;
    return {
      rate, feePct, coinFloorUsd, grossFloorUsd, cfgHi,
      siteLo, siteHi: capped ? balHi : cfgHi, capped,
      ok: rate > 0 && siteLo > 0 && cfgHi >= siteLo,
    };
  }, [config, asset, mode, balance]);

  /* ── Aksiyonlar ── */
  const createDeposit = async () => {
    if (!asset) return toast.error('Pick a coin first.');
    if (!preview || !Number.isFinite(preview.usd) || preview.usd <= 0
        || !Number.isFinite(preview.site) || preview.site <= 0)
      return toast.error('Enter a valid amount.');

    /* ⚠️ +1e-6 KASITLI. `preview.usd` float çarpımıyla üretiliyor ve
       (site/1000)*rate ikili gösterimde tam tutulamıyor: matematiksel olarak
       tam $5.00 olan bir tutar 4.999999999999999 çıkıp sente aşağı
       yuvarlanınca $4.99'a düşüyor ve TAM MİNİMUMDA girilen her tutar
       reddediliyordu. Hata sistematikti ve daima kullanıcı aleyhineydi. */
    const usdRounded = Math.floor(preview.usd * 100 + 1e-6) / 100;

    /* Alt sınır TEK yerden geliyor; coin bazlı taban devredeyse mesaj da
       sebebi söylüyor, çünkü "minimum $25" demek kullanıcıya neden bu kadar
       yüksek olduğunu anlatmıyor. */
    if (usdRounded < limits.minUsd)
      return toast.error(
        limits.coinFloorUsd > limits.globalMinUsd
          ? `${asset.label} on ${shortNet(asset.network)} starts at $${limits.minUsd.toFixed(2)} `
            + `because of that network's fees. Pick a lower-fee coin (USDT-TRC20, LTC) `
            + `or raise the amount.`
          : `Minimum deposit is $${limits.minUsd.toFixed(2)}.`,
        { duration: 9000 });

    if (limits.maxUsd > 0 && usdRounded > limits.maxUsd)
      return toast.error(`Maximum deposit is $${limits.maxUsd.toFixed(2)}.`);

    setLoading(true);
    try {
      const body = inputMode === 'usd'
        ? { asset: asset.code, usd_amount: usdRounded }
        : { asset: asset.code, site_amount: preview.site };
      const { data } = await axios.post(`${API}/game/crypto/deposit`, body, auth);
      setInvoice(data);
      setDepositDone(null);
      toast.success('Address ready — send the exact amount shown.');
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Could not create the deposit.');
    } finally { setLoading(false); }
  };

  const cancelDeposit = async () => {
    setLoading(true);
    try {
      await axios.post(`${API}/game/crypto/deposit/cancel`, {}, auth);
      setInvoice(null);
      toast('Deposit closed. Funds sent to that address are still credited.');
    } catch { toast.error('Could not close the deposit.'); }
    finally { setLoading(false); }
  };

  const submitWithdraw = async () => {
    if (!asset) return toast.error('Pick a coin first.');

    /* Kopyala-yapıştırda sık görülen satır sonu ve sıfır-genişlikli
       karakterler sunucudaki regex'i şaşırtmadan burada ayıklanır. */
    const addr = address.replace(/[\s\u200B-\u200D\uFEFF]/g, '');
    if (!addr) return toast.error('Enter your wallet address.');
    if (addr.length < 10 || addr.length > 128)
      return toast.error('That address doesn\u2019t look right \u2014 check it and try again.');

    /* ⚠️ MEMO ZORUNLU COINLERDE BLOKLA. Bu bir onay sorusu değil, sert bir
       engel: memo'suz gönderilen XRP/TON borsada KAYBOLUR ve geri dönüşü
       yoktur. */
    const tag = memo.replace(/[\s\u200B-\u200D\uFEFF]/g, '');
    if (asset.needs_memo && !tag)
      return toast.error(
        `${asset.label} withdrawals need a memo/destination tag. ` +
        'Without it your funds would be lost at the exchange.', { duration: 10000 });
    if (tag && !/^[A-Za-z0-9_-]{1,64}$/.test(tag))
      return toast.error('That memo/tag isn\u2019t valid \u2014 copy it exactly from your exchange.');

    /* Alt/üst sınır TEK yerden. Varlık bazlı ağ tabanı ve komisyon zaten
       `limits.siteLo` içinde; ayrı bir ikinci kapı koymak, ekranda geçerli
       görünen bir tutarın gönderimde reddedilmesi demekti. */
    // ⚠️ Girdi BB → mili-BB. Backend mili-BB bekliyor.
    const site = bbToMilli(amountInput);
    if (!Number.isFinite(site) || site <= 0)
      return toast.error('Enter a valid amount.');
    if (site < limits.siteLo)
      return toast.error(
        limits.coinFloorUsd > 0
          ? `${asset.label} withdrawals start at ${fmtLcCeil(limits.siteLo)} ${LC_CUR_CHIP} `
            + `($${limits.coinFloorUsd.toFixed(2)}) because of ${shortNet(asset.network)} `
            + `network fees. Pick a lower-fee coin (USDT-TRC20, LTC) or withdraw more.`
          : `Minimum withdrawal is ${fmtLcCeil(limits.siteLo)} ${LC_CUR_CHIP}.`,
        { duration: 9000 });
    if (site > limits.siteHi)
      return toast.error(limits.capped
        ? `You only have ${fmtLc(limits.siteHi)} ${LC_CUR_CHIP}.`
        : `Maximum withdrawal is ${fmtLc(limits.siteHi)} ${LC_CUR_CHIP}.`);

    /* ADIM 1 — bakiyeye DOKUNMADAN adresi doğrula. Checksum'ı
       doğrulanamayan ağlarda kullanıcı açık onay verene kadar çekim
       GÖNDERİLMEZ. */
    if (addrCheck === null) {
      setLoading(true);
      try {
        const { data } = await axios.post(`${API}/game/crypto/withdraw/preview`, {
          asset: asset.code, amount: site, address: addr, extra_id: tag || null
        }, auth);
        setAddrCheck(data.address_check === 'ok' ? 'ok' : 'unchecked');
        if (data.needs_confirmation) { setLoading(false); return; }
      } catch (e) {
        setLoading(false);
        if (e.response?.status === 404) {
          setAddrCheck('skip');            // eski arka uç: preview ucu yok
        } else {
          const d = e.response?.data?.detail;
          return toast.error(typeof d === 'string' ? d : 'Could not verify that address.');
        }
      }
      setLoading(false);
    }
    if (addrCheck === 'unchecked' && !addrConfirmed) {
      return toast.error('Please confirm you checked the address before continuing.');
    }

    // ADIM 2 — gerçek çekim
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/game/crypto/withdraw`, {
        asset: asset.code, amount: site, address: addr, extra_id: tag || null
      }, auth);
      setSubmitted(data);
      if (onCredited) onCredited();       // bakiye düştü — başlıktaki rakam tazelensin
      toast.success(data.needs_approval
        ? 'Withdrawal submitted — pending review.'
        : 'Withdrawal submitted — sending now.');
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Withdrawal could not be created.');
    } finally { setLoading(false); }
  };

  /* ── Yükleniyor / kapalı durumları ── */
  if (loadingCfg) {
    return <div className="py-16 flex justify-center"><Loader2 className="w-7 h-7 animate-spin text-zinc-500" /></div>;
  }

  /* ⚠️ Çekim altyapısı hazır değilse formu HİÇ gösterme. Aksi halde
     kullanıcı formu doldurup gönderiyor ve bakiyesi bir "düş → iade"
     turu yaşıyor. */
  if (mode === 'withdraw' && config?.enabled && config?.withdrawals_available === false) {
    const why = config?.withdraw_unavailable_reason;
    return (
      <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-5 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-amber-300 font-bold text-sm mb-1">Crypto withdrawals are paused</p>
          <p className="text-amber-200/70 text-xs leading-relaxed">
            {why === 'payouts_not_configured'
              ? 'Our payout system is being set up. Deposits still work normally — '
                + 'your balance is safe and withdrawals will reopen shortly.'
              : 'Withdrawal limits are being adjusted right now. You can still withdraw '
                + 'to Roblox in the meantime.'}
          </p>
        </div>
      </div>
    );
  }

  if (!config?.enabled || !config?.assets?.length) {
    return (
      <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-5 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
        <div className="min-w-0">
          <p className="text-amber-300 font-bold text-sm mb-1">Crypto is currently unavailable</p>
          <p className="text-amber-200/70 text-xs leading-relaxed">
            {cfgError === 'network'
              ? 'We could not reach the crypto service. Use the Roblox option in the '
                + 'meantime — this usually clears up on its own.'
              : 'Crypto payments are turned off right now. Use the Roblox option in the meantime.'}
          </p>
          {cfgError && (
            <button onClick={() => { setLoadingCfg(true); loadConfig(); }}
              className="mt-2.5 text-[11px] font-bold text-amber-300 hover:text-white transition-colors inline-flex items-center gap-1.5">
              <RefreshCw className="w-3 h-3" /> Try again
            </button>
          )}
        </div>
      </div>
    );
  }

  /* ⚠️ SINIRLAR KESİŞMİYORSA FORMU HİÇ GÖSTERME.
     Arka uç site limitleriyle gateway'in USD bandının KESİŞİMİNİ veriyor;
     oran değiştiğinde bu kesişim boşalabiliyor (min > max). O durumda
     HİÇBİR tutar kabul edilmez — form göstermek, kullanıcıyı ne girerse
     girsin reddedilecek bir alana davet etmek olur. */
  if (!limits || !limits.ok) {
    console.warn(`[wallet] crypto ${mode} limitleri geçersiz:`, limits);
    return (
      <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-5 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-amber-300 font-bold text-sm mb-1">
            Crypto {mode === 'deposit' ? 'deposits' : 'withdrawals'} are paused
          </p>
          <p className="text-amber-200/70 text-xs leading-relaxed">
            Our limits are being adjusted right now, so no amount can go through.
            Use the Roblox option in the meantime — your balance is safe.
          </p>
        </div>
      </div>
    );
  }

  /* ── Oran + canlı fiyat: TEK SATIR ──
     ⚠️ Oran 1.000 bakiye üzerinden gösteriliyor. Arka uç 1M üzerinden
     konuşuyor ama bu ölçekte 1M bakiye kimsenin göreceği bir tutar
     değil; kullanıcıya anlamsız bir referans vermek yerine kendi
     ölçeğinde konuşuyoruz. */
  /* Oran zaten 1.000 birim başına geliyor — ayrıca ölçeklemek YANLIŞ olur. */
  const dispRate = limits.rate;

  const renderRateLine = () => (
    <div className="flex items-center justify-between gap-2 px-0.5 text-[11px]">
      <span className="text-zinc-500 truncate">
        {fmtLc(RATE_UNIT)} {LC_CUR_CHIP} ={' '}
        <span className="text-zinc-300 font-semibold">
          ${dispRate < 0.01 ? dispRate.toFixed(4) : dispRate.toFixed(2)}
        </span>
      </span>
      {fmtPrice(asset?.price_usd) && (
        <span className="flex items-center gap-1.5 text-zinc-500 shrink-0">
          <span className="relative flex h-1.5 w-1.5">
            <span className="animate-ping absolute h-full w-full rounded-full opacity-70"
                  style={{ background: '#22c55e' }} />
            <span className="relative rounded-full h-1.5 w-1.5" style={{ background: '#22c55e' }} />
          </span>
          1 {(asset.label || '').toUpperCase()} ={' '}
          <span className="text-zinc-300 font-semibold mm-num">{fmtPrice(asset.price_usd)}</span>
        </span>
      )}
    </div>
  );

  /* Girişin HANGİ BİRİMDE olduğu. Çekimde her zaman site parası. */
  const isUsdInput = mode === 'deposit' && inputMode === 'usd';

  /* Seçili coin için geçerli USD tabanı — mesajlarda sebebi anlatmak için */
  const coinMinUsd = mode === 'deposit' ? limits.minUsd : limits.coinFloorUsd;

  /* Limitler DAİMA girişle aynı birimde gösterilir — kullanıcı "min $6"
     mı "min 6.000" mi olduğunu tahmin etmek zorunda kalmasın. */
  const limitLo = (mode === 'deposit' && isUsdInput) ? limits.minUsd : limits.siteLo;
  const limitHi = (mode === 'deposit' && isUsdInput) ? limits.maxUsd : limits.siteHi;

  /* ⚠️ ARALIK DIŞI TUTARI SESSİZ BIRAKMA. Önceden kullanıcı tutarı yazıp
     butona basana kadar bir şeyin yanlış olduğunu öğrenemiyordu; toast da
     yazdığı sayının yanında değil ekranın köşesinde beliriyordu. Sınır
     ihlali artık alanın hemen altında, girişle AYNI birimde duruyor. */
  // ⚠️ Karşılaştırma limitlerle AYNI birimde (mili-BB) yapılmalı; girdi
  // BB olduğu için önce çevrilir. Aksi hâlde ekranda geçerli görünen bir
  // tutar gönderimde reddedilir (kullanıcının yaşadığı hata buydu).
  const enteredAmount = isUsdInput
    ? (parseFloat(String(amountInput).replace(/[^0-9.]/g, '')) || 0)
    : bbToMilli(amountInput);
  const showUnit = (v) => (isUsdInput
    ? `$${Number(v).toFixed(2)}`
    : `${fmtLc(v)} ${LC_CUR_CHIP}`);
  const rangeMsg = !amountInput.trim() ? null
    : enteredAmount <= 0 ? 'Enter a valid amount.'
    : enteredAmount < limitLo
      ? `Minimum is ${isUsdInput ? `$${Number(limitLo).toFixed(2)}`
                                 : `${fmtLcCeil(limitLo)} ${LC_CUR_CHIP}`}.`
    : enteredAmount > limitHi
      ? (mode === 'withdraw' && limits.capped
          ? `That is more than your balance (${fmtLc(limitHi)} ${LC_CUR_CHIP}).`
          : `Maximum is ${showUnit(limitHi)}.`)
      : null;

  /* ⚠️ HAZIR TUTARLAR SABİT KODLANMAZ. Kaynak sitede bunlar '1b','5b','10b'
     idi; bu ölçekte hepsi üst sınırın çok üstünde kalıp tıklandığında
     anında hata veren üç ölü buton olurdu. Limitlerden türetiliyor. */
  const presets = isUsdInput
    ? [10, 25, 50, 100].filter(v => v >= limitLo && v <= limitHi)
    : [...new Set([
        limitLo,
        niceRound(limitHi / 4),
        niceRound(limitHi / 2),
        limitHi,
      ].map(v => Math.floor(v)).filter(v => v >= limitLo && v <= limitHi))];

  /* ═════════ DEPOSIT — başarı ekranı ═════════ */
  if (mode === 'deposit' && depositDone) {
    return (
      <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }}
        className="text-center space-y-5 py-4">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto border"
          style={{ background: `${T.accent}22`, borderColor: `${T.accent}55` }}>
          <CheckCircle2 className="w-10 h-10" style={{ color: T.accentSoft }} />
        </div>
        <div>
          <div className="flex justify-center mb-3">
            <CoinIcon code={depositDone.asset} size={28} />
          </div>
          <h3 className="text-white text-2xl font-bold mb-1">Balance added</h3>
          <p className="text-zinc-400 text-sm">
            <span className="text-white font-bold">{fmtLc(depositDone.amount)}</span> {LC_CUR}{' '}
            credited from your {String(depositDone.asset || '').toUpperCase()} deposit
            {depositDone.credited_usd ? ` ($${Number(depositDone.credited_usd).toFixed(2)})` : ''}.
          </p>
        </div>
        <button onClick={() => { setDepositDone(null); setAmountInput(''); }}
          className={`w-full py-3.5 bg-gradient-to-r ${T.btn} rounded-xl text-white font-bold transition-all`}>
          Deposit again
        </button>
      </motion.div>
    );
  }

  /* ═════════ DEPOSIT — ödeme ekranı ═════════ */
  if (mode === 'deposit' && invoice) {
    const expired = timeLeft <= 0;
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <CoinIcon code={invoice.asset} size={40} />
            <div className="min-w-0">
              <p className="text-[11px] uppercase tracking-wider text-zinc-500 font-bold">Send exactly</p>
              <p className="text-2xl font-bold text-white leading-tight truncate">
                {fmtCrypto(invoice.pay_amount)}{' '}
                <span style={{ color: T.accentSoft }}>
                  {(invoice.label || invoice.asset || '').toUpperCase()}
                </span>
              </p>
              <p className="text-xs text-zinc-500 mt-0.5 truncate">
                {shortNet(invoice.network)} · you receive ≈{' '}
                <span className="text-zinc-300 font-semibold">{fmtLc(invoice.site_amount)}</span> {LC_CUR}
              </p>
            </div>
          </div>
          <div className={`flex items-center gap-1.5 px-3 py-2 rounded-xl border ${expired ? 'border-rose-500/40 bg-rose-500/10' : 'border-[#2A2D31] bg-[#15171a]'}`}>
            <Clock className={`w-3.5 h-3.5 ${expired ? 'text-rose-400' : 'text-zinc-400'}`} />
            <span className={`mm-num text-sm font-bold ${expired ? 'text-rose-400' : 'text-white'}`}>
              {mmss(timeLeft)}
            </span>
          </div>
        </div>

        <div className="flex justify-center py-1">
          <div className="p-2.5 bg-white rounded-2xl">
            <QRCodeSVG value={invoice.pay_address} size={140} level="M" />
          </div>
        </div>

        <CopyField label={`${shortNet(invoice.network)} address`} value={invoice.pay_address} accent={T.accent} />
        <CopyField label="Exact amount" value={fmtCrypto(invoice.pay_amount)} accent={T.accent} />

        {invoice.extra_id && (
          <>
            <CopyField label="Memo / tag (required)" value={invoice.extra_id} accent={T.accent} />
            <div className="bg-rose-500/10 border border-rose-500/25 rounded-xl p-3 flex gap-2.5">
              <AlertTriangle className="w-4 h-4 text-rose-400 shrink-0 mt-0.5" />
              <p className="text-[11px] text-rose-300/90 leading-relaxed">
                Send the memo/tag with your transfer. Without it the network can&apos;t match your deposit.
              </p>
            </div>
          </>
        )}

        <div className="bg-[#15171a] border border-[#2A2D31] rounded-xl p-3.5 space-y-1.5">
          <p className="text-[11px] text-zinc-400 leading-relaxed">
            • Send only <span className="text-white font-bold">{(invoice.label || invoice.asset || '').toUpperCase()}</span> on{' '}
            <span className="text-white font-bold">{shortNet(invoice.network)}</span>. Other coins or networks are lost.
          </p>
          <p className="text-[11px] text-zinc-400 leading-relaxed">
            • Credited from what <span className="text-white font-bold">actually arrives</span>, at the
            live coin price, using the site rate locked when you started.
          </p>
          <p className="text-[11px] text-zinc-400 leading-relaxed">
            • The timer only fixes the quoted coin amount — late transfers are still credited.
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 py-1">
          <Loader2 className="w-4 h-4 animate-spin" style={{ color: T.accent }} />
          <span className="text-sm text-zinc-400">Waiting for your transfer…</span>
        </div>

        <button onClick={cancelDeposit} disabled={loading}
          className="w-full py-3 bg-[#15171a] border border-[#2A2D31] hover:border-zinc-600 rounded-xl text-zinc-400 text-sm font-bold transition-colors disabled:opacity-50">
          Close this deposit
        </button>
      </motion.div>
    );
  }

  /* ═════════ WITHDRAW — gönderildi ═════════ */
  if (mode === 'withdraw' && submitted) {
    return (
      <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }}
        className="text-center space-y-5 py-4">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto border"
          style={{ background: `${T.accent}22`, borderColor: `${T.accent}55` }}>
          <CheckCircle2 className="w-10 h-10" style={{ color: T.accentSoft }} />
        </div>
        <div>
          <h3 className="text-white text-2xl font-bold mb-1">
            {submitted.needs_approval ? 'Withdrawal pending review' : 'Withdrawal sent'}
          </h3>
          <p className="text-zinc-400 text-sm leading-relaxed">
            {fmtCrypto(submitted.crypto_amount)} {(submitted.asset || '').toUpperCase()} (${submitted.usd_amount})
            {submitted.needs_approval
              ? ' will be released once an admin approves it.'
              : ' is on its way to your wallet.'}
          </p>
        </div>
        {/* Adres onayı da SIFIRLANIR: her çekim için yeniden doğrulansın. */}
        <button onClick={() => {
          setSubmitted(null); setAmountInput(''); setWdStep('amount');
          setAddress(''); setMemo('');
          setAddrCheck(null); setAddrConfirmed(false);
        }}
          className={`w-full py-3.5 bg-gradient-to-r ${T.btn} rounded-xl text-white font-bold transition-all`}>
          New withdrawal
        </button>
      </motion.div>
    );
  }

  /* ═════════ FORM (deposit & withdraw ortak) ═════════ */
  const balKnown = Number.isFinite(Number(balance));

  return (
    <AnimatePresence mode="wait">
      <motion.div key={`crypto-${mode}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }}
        className="space-y-3.5">

        {/* ══════════ ADIM 1 — COIN & TUTAR ══════════ */}
        {(mode === 'deposit' || wdStep === 'amount') && (<>
          <CoinSelect
            assets={config.assets} value={asset} onChange={setAsset}
            accent={T.accent} mode={mode}
            header={
              /* GERİ + BAŞLIK + BAKİYE, TEK SATIR.
                 ⚠️ Bakiye burada olmak ZORUNDA. Cüzdan geçiş düğmeleri
                 kaldırıldıktan sonra kullanıcının "BB Coin'imde ne kadar
                 var?" sorusunu soracağı tek yer bu ekran — ve yatırırken de
                 çekerken de aynı yerde, aynı biçimde duruyor. */
              <div className="flex items-center gap-3">
                {onBack && <BackButton onClick={onBack} testId={`crypto-${mode}-back`} />}
                <span className="font-heading font-bold text-white text-[19px] leading-none flex-1 min-w-0 truncate">
                  Coin &amp; network
                </span>
                {balKnown && (
                  <span className="text-right shrink-0">
                    <span className="mm-num font-bold text-white text-[15px] inline-flex
                                     items-center gap-1.5 leading-none">
                      {fmtLc(balance)}<BbIcon size={14} />
                    </span>
                    <span className="mm-eyebrow block mt-1.5">{LC_CUR_CHIP}</span>
                  </span>
                )}
              </div>
            }
          />
          {renderRateLine()}

          <div className="space-y-2.5">
            <div className="flex items-center justify-between gap-3">
              <label className="text-sm text-zinc-400">
                {mode === 'deposit' ? 'You want to' : `Withdraw from ${LC_CUR}`}
              </label>

              {mode === 'deposit' ? (
                <div className="flex p-0.5 rounded-lg bg-[#15171a] border border-[#2A2D31]">
                  {[['site', LC_CUR_CHIP], ['usd', 'US Dollar']].map(([k, lbl]) => (
                    <button
                      key={k} type="button"
                      onClick={() => { setInputMode(k); setAmountInput(''); }}
                      className="px-2.5 py-1 rounded-md text-[11px] font-bold transition-colors"
                      style={inputMode === k
                        ? { background: T.accent, color: '#fff' }
                        : { color: '#71717a' }}
                    >
                      {lbl}
                    </button>
                  ))}
                </div>
              ) : (balKnown && (
                /* Çekimde kullanıcının elindeki tutarı göstermek, "yetersiz
                   bakiye" hatasını hiç doğmadan önlüyor. */
                <span className="text-[11px] text-zinc-500 shrink-0">
                  available <span className="text-zinc-300 font-bold inline-flex items-center gap-1">{fmtLc(balance)} <BbIcon size={12} /></span>
                </span>
              ))}
            </div>

            <div className="relative">
              {isUsdInput && (
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-lg font-bold"
                      style={{ color: T.accent }}>$</span>
              )}
              <input
                type="text" inputMode="decimal"
                value={amountInput}
                /* ⚠️ BB girdisi KESİR kabul eder (0.5 BB = 500 mili-BB).
                   sanitizeAmountInput tam sayıya zorluyordu; küçük tutarlar
                   yazılamıyordu. */
                onChange={e => setAmountInput(isUsdInput
                  ? sanitizeUsdInput(e.target.value)
                  : sanitizeBbInput(e.target.value))}
                placeholder={isUsdInput ? '25.00' : milliToBbInputCeil(limitLo)}
                className={`w-full py-4 ${isUsdInput ? 'pl-9' : 'pl-4'} pr-24 bg-[#15171a]
                            border border-[#2A2D31] rounded-xl text-white text-lg font-bold
                            outline-none ${T.ring} transition-colors`}
              />
              <span className="absolute right-3.5 top-1/2 -translate-y-1/2">
                <UnitChip tone={isUsdInput ? 'neutral' : 'accent'} accent={T.accent}>
                  {isUsdInput ? 'USD' : LC_CUR_CHIP}
                </UnitChip>
              </span>
            </div>

            {/* Ağ minimumu site minimumundan YÜKSEKSE bunu söyle — şaşırtıcı
                olan durum budur. */}
            {mode === 'deposit' && coinMinUsd > Number(config.min_deposit_usd || 0) && (
              <p className="text-[10px] text-amber-500/70 leading-relaxed px-0.5">
                {asset?.label} on {shortNet(asset?.network)} needs at least{' '}
                <span className="font-bold">${coinMinUsd.toFixed(2)}</span> — that network&apos;s fee floor.
              </p>
            )}

            {rangeMsg && (
              <p className="text-[11px] text-rose-400/90 leading-relaxed px-0.5">{rangeMsg}</p>
            )}

            <div className="flex items-center justify-between gap-2 text-[11px]">
              <button
                type="button"
                /* ⚠️ Kutuya BB yazılır (limitLo mili-BB'dir). Ham değeri
                   yazmak, butona basan kullanıcıya anında "maksimumu aştın"
                   dedirtirdi. */
                onClick={() => setAmountInput(isUsdInput
                  ? Number(limitLo).toFixed(2) : milliToBbInputCeil(limitLo))}
                className="text-zinc-500 hover:text-zinc-300 transition-colors"
              >
                Min <span className="text-zinc-300 font-bold">
                  {isUsdInput ? `$${Number(limitLo).toFixed(2)}` : fmtLcCeil(limitLo)}
                </span>
              </button>
              <span className="text-zinc-700">·</span>
              <button
                type="button"
                onClick={() => setAmountInput(isUsdInput
                  ? Number(limitHi).toFixed(2) : milliToBbInput(limitHi))}
                className="text-zinc-500 hover:text-zinc-300 transition-colors"
              >
                {/* Üst sınır bakiyeden geliyorsa "Max" demek yanıltıcı:
                    kullanıcı sitenin sınırını sanır, oysa kendi parası. */}
                {mode === 'withdraw' && limits.capped ? 'All' : 'Max'}{' '}
                <span className="text-zinc-300 font-bold">
                  {isUsdInput ? `$${Number(limitHi).toFixed(2)}` : fmtLc(limitHi)}
                </span>
              </button>
            </div>

            {presets.length > 1 && (
              <div className="flex gap-2">
                {presets.map(v => (
                  <button key={v} type="button"
                    /* Preset değerleri mili-BB; kutuya BB olarak yazılır. */
                    onClick={() => setAmountInput(isUsdInput ? String(v) : milliToBbInput(v))}
                    className="flex-1 py-2 rounded-lg text-xs font-bold bg-[#15171a] border
                               border-[#2A2D31] text-zinc-400 hover:text-white
                               hover:border-zinc-600 transition-colors">
                    {isUsdInput ? `$${v}` : fmtLc(v)}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* ══════ DÖNÜŞÜM KARTI ══════
              Üst satır GERÇEK PARA, alt satır SİTE PARASI (ya da tersi).
              İkisi farklı renk, farklı ikon ve farklı rozetle gösteriliyor —
              ikisi de rakam olduğu için başka türlü ayırt edilemiyor. */}
          {/* ⚠️ ÇEKİM KARTI YATIRIMLA AYNI DÜZENDE OLMALI.
              Eski hâli tek satırdı ve dolar karşılığı sonda küçük gri bir
              yazıydı. Kullanıcı GERÇEK PARA çekerken en çok merak ettiği
              rakam odur; yatırımda belirgin gösterip çekimde saklamak
              tutarsızdı. Artık iki panel: ne gönderiyor / ne alıyor. */}
          {mode === 'withdraw' && preview && preview.usd > 0 && (
            <div className="rounded-xl border overflow-hidden"
                 style={{ borderColor: '#2A2D31', background: '#15171a' }}>

              <div className="p-3.5 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-[10px] uppercase tracking-wider text-zinc-600 font-bold mb-1">
                    You send
                  </p>
                  <div className="flex items-center gap-2">
                    <Coins className="w-4 h-4 shrink-0" style={{ color: T.accent }} />
                    <span className="text-base font-bold text-white truncate">
                      {fmtLc(preview.site)}
                    </span>
                    <BbIcon size={14} />
                  </div>
                </div>
                <div className="text-right shrink-0">
                  {/* Brüt değer — komisyon kesilmeden önceki karşılık. */}
                  <p className="text-base font-bold text-white">${(preview.gross ?? preview.usd).toFixed(2)}</p>
                  <UnitChip>USD</UnitChip>
                </div>
              </div>

              {/* Komisyon varsa ARADA gösterilir: kullanıcı brütten nete
                  nasıl gidildiğini adım adım görür, sonucu tahmin etmez. */}
              {preview.gross > preview.usd && (
                <div className="px-3.5 py-2 flex items-center justify-between border-t"
                     style={{ borderColor: '#2A2D31', background: '#121417' }}>
                  <span className="text-[11px] text-zinc-500">
                    Network &amp; processing fee ({config.withdraw_fee_percent}%)
                  </span>
                  <span className="text-[11px] mm-num text-rose-400/80">
                    −${(preview.gross - preview.usd).toFixed(2)}
                  </span>
                </div>
              )}

              <div className="relative h-px" style={{ background: '#2A2D31' }}>
                <span className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2
                                 w-6 h-6 rounded-full flex items-center justify-center"
                      style={{ background: '#15171a', border: '1px solid #2A2D31' }}>
                  <ArrowDown className="w-3 h-3 text-zinc-500" />
                </span>
              </div>

              <div className="p-3.5 flex items-end justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-[10px] uppercase tracking-wider text-zinc-600 font-bold mb-1">
                    You receive
                  </p>
                  <div className="flex items-center gap-2">
                    {asset && <CoinIcon code={asset.code} size={20} />}
                    <span className="text-xl font-bold truncate" style={{ color: T.accentSoft }}>
                      {preview.crypto ? fmtCrypto(preview.crypto, 6) : '≈'}
                    </span>
                    <span className="text-[11px] font-bold text-zinc-500 shrink-0">
                      {(asset?.label || '').toUpperCase()}
                    </span>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <p className="text-base font-bold" style={{ color: T.accentSoft }}>
                    ${preview.usd.toFixed(2)}
                  </p>
                  <UnitChip>NET USD</UnitChip>
                </div>
              </div>

              <div className="px-3.5 py-2 border-t"
                   style={{ borderColor: '#2A2D31', background: '#121417' }}>
                <p className="text-[10px] text-zinc-600 leading-relaxed">
                  {/* Yatırımdaki notun karşılığı: kullanıcı tam coin miktarının
                      neden değişebileceğini bilmeli. */}
                  Final coin amount follows the live price when the payout is sent.
                </p>
              </div>
            </div>
          )}

          {mode === 'deposit' && preview && preview.usd > 0 && (
            <div className="rounded-xl border overflow-hidden"
                 style={{ borderColor: '#2A2D31', background: '#15171a' }}>

              <div className="p-3.5 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-[10px] uppercase tracking-wider text-zinc-600 font-bold mb-1">
                    You send
                  </p>
                  <div className="flex items-center gap-2">
                    {asset && <CoinIcon code={asset.code} size={20} />}
                    <span className="text-base font-bold text-white truncate">
                      {preview.crypto ? fmtCrypto(preview.crypto, 6) : '≈'} {(asset?.label || '').toUpperCase()}
                    </span>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <p className="text-base font-bold text-white">${preview.usd.toFixed(2)}</p>
                  <UnitChip>USD</UnitChip>
                </div>
              </div>

              <div className="relative h-px" style={{ background: '#2A2D31' }}>
                <span className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2
                                 w-6 h-6 rounded-full flex items-center justify-center"
                      style={{ background: '#15171a', border: '1px solid #2A2D31' }}>
                  <ArrowDown className="w-3 h-3 text-zinc-500" />
                </span>
              </div>

              <div className="p-3.5">
                <p className="text-[10px] uppercase tracking-wider text-zinc-600 font-bold mb-1">
                  You receive
                </p>
                <div className="flex items-center gap-2">
                  <Coins className="w-4 h-4" style={{ color: T.accent }} />
                  <span className="text-xl font-bold" style={{ color: T.accentSoft }}>
                    {fmtLc(preview.site)}
                  </span>
                  <BbIcon size={14} />
                </div>
              </div>

              <div className="px-3.5 py-2 border-t"
                   style={{ borderColor: '#2A2D31', background: '#121417' }}>
                <p className="text-[10px] text-zinc-600 leading-relaxed">
                  Final coin amount follows the live price when the transfer settles.
                </p>
              </div>
            </div>
          )}
        </>)}

        {/* ══════════ ADIM 2 — ADRES (yalnızca çekim) ══════════ */}
        {mode === 'withdraw' && wdStep === 'address' && (
          <>
            {/* Özet şeridi: kullanıcı ne çektiğini adres girerken de görür */}
            <div className="flex items-center justify-between gap-3 p-3 rounded-xl border"
                 style={{ borderColor: `${T.accent}33`, background: `${T.accent}0f` }}>
              <button
                type="button" onClick={() => setWdStep('amount')}
                className="flex items-center gap-1.5 text-[11px] font-bold text-zinc-400 hover:text-white transition-colors shrink-0"
              >
                <ArrowLeft className="w-3.5 h-3.5" />
                Edit
              </button>
              {/* ⚠️ Adres girilirken de NET DOLAR görünmeli: kullanıcı bu
                  ekranda "gönder"e basıyor ve ne alacağını burada teyit
                  ediyor. Tutar adımına geri dönüp bakmak zorunda kalmamalı. */}
              <div className="flex items-center gap-2 min-w-0">
                <span className="text-sm font-bold text-white inline-flex items-center gap-1">{fmtLc(preview?.site || 0)} <BbIcon size={13} /></span>
                <ArrowRightLeft className="w-3 h-3 text-zinc-600 shrink-0" />
                {asset && <CoinIcon code={asset.code} size={18} />}
                <span className="text-sm font-bold truncate" style={{ color: T.accentSoft }}>
                  {preview?.crypto ? fmtCrypto(preview.crypto, 6) : '≈'} {(asset?.label || '').toUpperCase()}
                </span>
                {preview?.usd > 0 && (
                  <span className="text-[11px] mm-num text-zinc-400 shrink-0 whitespace-nowrap">
                    ≈ ${preview.usd.toFixed(2)}
                  </span>
                )}
              </div>
            </div>

            {/* ⚠️ KRİPTO KOMİSYONU, ROBLOX'UN %30'U DEĞİLDİR. Ayrı bir
                kesinti, ayrı bir isim — aynı modalda ikisini aynı kelimeyle
                anlatmak kullanıcıyı yanıltır. */}
            {Number(config.withdraw_fee_percent) > 0 && preview && (
              <div className="bg-[#15171a] border border-[#2A2D31] rounded-xl p-3 space-y-1.5">
                <div className="flex justify-between text-xs">
                  <span className="text-zinc-500">Withdrawal value</span>
                  <span className="text-zinc-300 mm-num">${preview.gross.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-xs">
                  <span className="text-zinc-500">Crypto withdrawal fee ({config.withdraw_fee_percent}%)</span>
                  <span className="text-rose-400/80 mm-num">
                    −${(preview.gross - preview.usd).toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between text-sm pt-1.5 border-t border-[#2A2D31]">
                  <span className="text-zinc-300 font-bold">You receive</span>
                  <span className="font-bold mm-num" style={{ color: T.accentSoft }}>
                    ${preview.usd.toFixed(2)}
                  </span>
                </div>
              </div>
            )}

            <div className="space-y-2">
              <label className="text-sm text-zinc-400">
                Your {asset?.label} address ({shortNet(asset?.network)})
              </label>
              <div className="relative">
                <Wallet className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-zinc-600" />
                <input
                  type="text" value={address} onChange={e => setAddress(e.target.value)}
                  placeholder="Paste your wallet address"
                  className={`w-full p-4 pl-11 bg-[#15171a] border border-[#2A2D31] rounded-xl text-white mm-num text-sm outline-none ${T.ring} transition-colors`}
                />
              </div>
            </div>

            {asset?.needs_memo && (
              <div className="space-y-2">
                <label className="text-sm text-zinc-400">
                  Memo / destination tag <span className="text-rose-400">*required</span>
                </label>
                <input
                  type="text" value={memo} onChange={e => setMemo(e.target.value)}
                  placeholder="Copy it exactly from your exchange"
                  className={`w-full p-4 bg-[#15171a] border border-[#2A2D31] rounded-xl text-white mm-num text-sm outline-none ${T.ring} transition-colors`}
                />
              </div>
            )}

            {/* Checksum'ı DOĞRULANAMAYAN adres → sert onay kapısı */}
            {addrCheck === 'unchecked' && (
              <div className="bg-rose-500/10 border border-rose-500/30 rounded-xl p-3 space-y-2.5">
                <div className="flex gap-2.5">
                  <AlertTriangle className="w-4 h-4 text-rose-400 shrink-0 mt-0.5" />
                  <p className="text-[11px] text-rose-200/90 leading-relaxed">
                    <span className="font-bold text-rose-300">This network can&apos;t verify addresses.</span>{' '}
                    {shortNet(asset?.network)} addresses carry no built-in checksum, so a single wrong
                    character cannot be detected — the funds would be lost permanently.
                  </p>
                </div>
                <div className="bg-[#15171a] border border-[#2A2D31] rounded-lg p-2.5">
                  <p className="text-[10px] text-zinc-500 mb-1">Compare these against your wallet:</p>
                  <p className="mm-num text-xs break-all">
                    <span className="text-rose-300 font-bold">{address.replace(/\s/g, '').slice(0, 6)}</span>
                    <span className="text-zinc-600">{address.replace(/\s/g, '').slice(6, -6)}</span>
                    <span className="text-rose-300 font-bold">{address.replace(/\s/g, '').slice(-6)}</span>
                  </p>
                </div>
                <label className="flex items-start gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox" checked={addrConfirmed}
                    onChange={e => setAddrConfirmed(e.target.checked)}
                    className="mt-0.5 accent-rose-500"
                  />
                  <span className="text-[11px] text-zinc-300 leading-relaxed">
                    I compared this address with my wallet, character by character.
                  </span>
                </label>
              </div>
            )}

            <p className="flex items-start gap-2 text-[11px] text-amber-500/80 leading-relaxed px-0.5">
              <AlertTriangle className="w-3.5 h-3.5 shrink-0 mt-0.5" />
              <span>Transfers can&apos;t be reversed — check the address and network.</span>
            </p>
          </>
        )}

        <button
          onClick={() => {
            if (mode === 'deposit') return createDeposit();
            // Adım 1'de tutarı DOĞRULA, sonra adrese geç.
            if (wdStep === 'amount') {
              const pv = preview;
              if (!pv || pv.site <= 0) return toast.error('Enter an amount.');
              if (pv.site < limitLo)
                return toast.error(`Minimum withdrawal is ${fmtLcCeil(limitLo)} ${LC_CUR_CHIP}.`);
              if (pv.site > limitHi)
                return toast.error(`Maximum withdrawal is ${fmtLc(limitHi)} ${LC_CUR_CHIP}.`);
              if (balKnown && pv.site > Number(balance))
                return toast.error(`You only have ${fmtLc(balance)} ${LC_CUR_CHIP}.`);
              return setWdStep('address');
            }
            return submitWithdraw();
          }}
          disabled={loading || !asset || !amountInput
            /* Sebep alanın hemen altında yazıyor; buton da ona uymalı.
               Yazarken değil, ancak geçersiz bir tutar durduğunda kilitlenir. */
            || ((mode === 'deposit' || wdStep === 'amount') && !!rangeMsg)
            || (mode === 'withdraw' && wdStep === 'address' && !address.trim())
            || (mode === 'withdraw' && wdStep === 'address' && asset?.needs_memo && !memo.trim())
            || (mode === 'withdraw' && wdStep === 'address'
                && addrCheck === 'unchecked' && !addrConfirmed)}
          className={`w-full py-4 bg-gradient-to-r ${T.btn} rounded-xl text-white font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {loading ? <Loader2 className="animate-spin mx-auto w-6 h-6" />
            : mode === 'deposit' ? 'Get deposit address'
            : wdStep === 'amount' ? 'Continue'
            : addrCheck === 'unchecked' ? 'Confirm & withdraw'
            : 'Request withdrawal'}
        </button>

        <p className="text-[10px] text-zinc-600 text-center leading-relaxed">
          {mode === 'deposit'
            ? (isUsdInput
                ? `Min $${Number(limitLo).toFixed(2)} · Max $${Number(limitHi).toFixed(2)} USD per deposit`
                : `Min ${fmtLc(limitLo)} · Max ${fmtLc(limitHi)} ${LC_CUR_CHIP} per deposit`)
            : wdStep === 'address'
              ? `Sending on ${shortNet(asset?.network)} · double-check the network`
              : `Min ${fmtLcCeil(limitLo)} ${LC_CUR_CHIP} · ${limits.capped ? 'your balance' : 'Max ' + fmtLc(limitHi) + ' ' + LC_CUR_CHIP}`
                + ` ${LC_CUR_CHIP} per withdrawal`
                + (coinMinUsd > 0 ? ` · ${asset?.label} floor $${coinMinUsd.toFixed(2)}` : '')}
        </p>
      </motion.div>
    </AnimatePresence>
  );
};

/* ═══════════════════════════════════════════════════════════
   ÖDEME YÖNTEMİ SEÇİCİ

   Deposit/Withdraw sekmelerinin İÇİNDE durur ve aksiyon rengini
   (mor/yeşil) KORUR: kullanıcının ne yaptığı değişmiyor, yalnızca
   hangi rayı kullandığı. CryptoPanel de kendini mode'a göre aynı
   renkle boyadığı için geçiş kesintisiz görünür.
   ═══════════════════════════════════════════════════════════ */
// ══════════════════════════════════════════════════════════════════════
// 🪙 CÜZDAN SEÇİM KARTI
// ══════════════════════════════════════════════════════════════════════
// Eski akışta önce "Deposit" sekmesi, sonra Roblox/Crypto yöntem anahtarı
// vardı — yani kullanıcı HANGİ BAKİYEYİ yüklediğini hiç seçmiyordu, yöntem
// dolaylı olarak cüzdanı belirliyordu. İki ayrı cüzdan varken bu kafa
// karıştırıcı: "Crypto ile yatırırsam Robux'um mu artar?" sorusunun cevabı
// arayüzde görünmüyordu.
// Yeni akış cüzdanı ÖNCE sorar; yöntemler o cüzdana göre listelenir.
const WalletPickCard = ({ id, title, subtitle, amount, footer, onClick, mode = 'deposit' }) => {
  const isLc = id === 'lc';
  /* Cüzdanın kimlik rengi. Tek yerde tanımlanır ve kartın her yerinde
     aynı değişkenden okunur — daha önce aynı sarı üç ayrı yerde üç ayrı
     alfayla elle yazılıydı. */
  const tint = isLc ? '#F5B700' : '#B059E8';
  const coins = ['btc', 'eth', 'ltc', 'usdttrc20'];

  return (
    <button type="button" onClick={onClick}
      data-testid={`pick-wallet-${id}`}
      className="mm-focus group relative overflow-hidden text-left rounded-[14px] p-4 transition-colors
                 bg-[#141719] border border-[#2A2D31] hover:border-[var(--tint)]/50"
      style={{ '--tint': tint }}>

      {/* ══ FİLİGRAN ══
          Kartın hangi ray olduğunu YAZIYI OKUMADAN söyleyen katman.
          MM2 rayında oyunun kendi logosu, kripto rayında BB parası.
          ⚠️ Sağ ALTA taşındı ve kırpıldı: ortada dururken metnin arkasından
          geçiyor ve okunurluğu düşürüyordu. */}
      <div aria-hidden className="absolute -right-6 -bottom-7 opacity-[0.09] group-hover:opacity-[0.16] transition-opacity duration-300 pointer-events-none">
        {isLc ? <BigBb /> : <Mm2Logo size={104} alt="" />}
      </div>

      {/* Üstte, kartın rengiyle 1px'lik bir aksan. Kartlar aynı gri kutu
          olmaktan çıkıp kimlik kazanıyor; renkli dolgu yapmaya gerek yok. */}
      <span aria-hidden className="absolute top-0 left-4 right-4 h-px"
        style={{ background: `linear-gradient(90deg, transparent, ${tint}99, transparent)` }} />

      <div className="relative">
        <div className="flex items-center gap-2 mb-3">
          {isLc ? <CoinBb size={20} /> : <CoinDiamond size={20} />}
          <span className="font-heading font-bold text-white text-lg leading-none">{title}</span>
        </div>

        {/* ÖDEME YÖNTEMİ — kartın asıl ayırt edici bilgisi.
            ⚠️ MM2 rayında artık oyunun GERÇEK logosu duruyor. Eski hâli
            yeşil bir daire içinde "MM" yazan uydurma bir rozetti; MM2'yi
            bilen bir oyuncu için hiçbir şey ifade etmiyordu. */}
        {/* ⚠️ LOGO 19px'TEN 30px'E ÇIKTI. Sebep dosyanın kendisinde:
            mm2logo.png 284×284 bir tuval ama gerçek çizim yalnızca
            100 piksel geniş — yani genişliğin ~%35'i. 19px'e kurulunca
            amblem 7 piksel kalıyor ve kırmızı bir leke gibi görünüyordu.
            30px'te çizim ~10.5px oluyor ve bıçak seçilebiliyor.
            Kripto tarafında dört para simgesi zaten kendi genişliklerini
            dolduruyor, o yüzden onlar 19px'te kalıyor — aynı sayıyı iki
            tarafa vermek eşitlik değil, yalnızca aynı sayı olurdu. */}
        <div className="flex items-center gap-2.5 mb-3 min-h-[30px]">
          {isLc ? (
            <div className="flex -space-x-1.5 shrink-0">
              {coins.map(c => <CoinIcon key={c} code={c} size={19} />)}
            </div>
          ) : (
            <Mm2Logo size={30} />
          )}
          <span className="text-[11px] font-bold text-zinc-300 truncate">
            {isLc ? 'BTC · ETH · LTC · USDT' : 'Murder Mystery 2 items'}
          </span>
        </div>

        <p className="text-[11px] text-zinc-500 leading-snug mb-4 min-h-[30px]">{subtitle}</p>

        <div className="flex items-end justify-between gap-2 pt-3 border-t border-[#2A2D31]">
          <div className="min-w-0">
            <p className="mm-eyebrow mb-1">Balance</p>
            <p className="mm-num font-bold text-[15px] text-white truncate">{amount}</p>
          </div>
          <span className="inline-flex items-center gap-1 text-[11px] font-bold px-2.5 py-1.5 rounded-lg transition-colors shrink-0"
            style={{ background: `${tint}1f`, color: tint }}>
            {footer} <ChevronRight className="w-3.5 h-3.5" />
          </span>
        </div>
      </div>
    </button>
  );
};

// 🪙 Simgeler TEK KAYNAKTAN (AuthContext). Modal'ın kendi CSS kopyaları
// kaldırıldı: coin'de "B" yazıyordu (marka "BB") ve site tarafı
// döndürülmüş kareydi — Robux'ta hiçbir anlamı yok.
const CoinDiamond = ({ size = 16 }) => <RobuxIcon size={size} />;
const CoinBb = ({ size = 16 }) => <BbIcon size={size} />;
/* Kart arka planındaki büyük filigran.
   ⚠️ `BigDiamond` SİLİNDİ: MM2 rayı artık oyunun gerçek logosunu
   kullanıyor (bkz. WalletPickCard), çizilmiş bir para değil. */
const BigBb = () => <BbIcon size={96} />;

// ══════════════════════════════════════════════════════════════════════
// BREADCRUMB BAŞLIĞI — "Deposit › Buy BB Coin" + karşı cüzdana geçiş
// ══════════════════════════════════════════════════════════════════════
// Kullanıcı hangi cüzdanı yüklediğini HER AN görmeli ve tek tıkla diğerine
// geçebilmeli; aksi hâlde geri gidip baştan seçmek zorunda kalır.
const FlowHeader = ({ root, walletId, onBack, onSwap }) => {
  const isLc = walletId === 'lc';
  const name = isLc ? LC_CUR : SITE_CUR;
  const other = isLc ? SITE_CUR : LC_CUR;
  return (
    <div className="mb-4">
      <button type="button" onClick={onBack}
        className="flex items-center gap-1.5 text-[11px] text-zinc-500 hover:text-zinc-300 transition-colors mb-3">
        <ArrowLeft className="w-3 h-3" />
        <span>{root}</span>
        <ChevronRight className="w-3 h-3" />
        <span className="text-zinc-300 font-semibold">{root === 'Withdraw' ? `From ${name}` : `Top up ${name}`}</span>
      </button>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          {isLc ? <CoinBb size={20} /> : <CoinDiamond size={20} />}
          <h3 className="font-black text-white text-lg">{root === 'Withdraw' ? `Cash out ${name}` : `Top up ${name}`}</h3>
        </div>
        <button type="button" onClick={onSwap}
          data-testid="swap-wallet-flow"
          className="inline-flex items-center gap-1.5 text-[11px] font-bold px-3 py-2 rounded-lg bg-white/5 hover:bg-white/10 text-zinc-300 hover:text-white border border-[#2A2D31] transition-colors">
          <ArrowRightLeft className="w-3.5 h-3.5" />
          {root === 'Withdraw' ? `Cash out ${other} instead` : `Top up ${other} instead`}
        </button>
      </div>
    </div>
  );
};

// Yöntem kartı — referanstaki kare kartların bizim akışa uyarlanmış hâli.
const MethodCard = ({ Icon, title, hint, onClick, disabled, accent = '#B059E8', badge }) => (
  <button type="button" onClick={onClick} disabled={disabled}
    className="group relative flex flex-col items-start gap-2 p-4 rounded-2xl bg-[#15171a] border border-[#2A2D31]
               hover:border-[#3a3d43] hover:bg-[#181b1f] transition-all text-left disabled:opacity-40 disabled:cursor-not-allowed min-h-[112px]">
    {badge && (
      <span className="absolute top-2.5 right-2.5 text-[9px] font-black uppercase tracking-wider px-1.5 py-0.5 rounded bg-white/10 text-zinc-400">{badge}</span>
    )}
    <span className="flex items-center justify-center w-9 h-9 rounded-xl shrink-0"
          style={{ background: `${accent}22`, color: accent }}>
      <Icon className="w-4.5 h-4.5" style={{ width: 18, height: 18 }} />
    </span>
    <span className="font-bold text-white text-sm">{title}</span>
    <span className="text-[10px] text-zinc-500 leading-snug">{hint}</span>
  </button>
);


// ══════════════════════════════════════════════════════════════════════

const ModalContent = ({ isOpen, onClose, initialTab = 'deposit' }) => {
  const navigate = useNavigate();

  // "Bu ben değilim" → önce MODALI KAPAT, sonra profile git.
  // Kapatmadan yönlendirmek modalı sayfa değişse de ekranda bırakıyordu.
  const goChangeAccount = () => {
    onClose();
    navigate('/dashboard');
  };

  // Modal AÇIK kalırsa sayfa arkada değişir ve kullanıcı hiçbir şey olmamış
  // gibi görür; önce kapatıyoruz.
  const goActiveWithdrawals = () => {
    onClose();
    navigate('/withdraws');
  };

  const { token, user, refreshUser,
          wallet, isLc, balance: activeBalance, fmtMoney, walletMeta,
          /* ⚠️ BİRİMİ ADINDA OLAN ALANLAR KULLANILIR.
             🔴 KAPATILAN HATA: bakiye kontrolü `activeBalance` ile
             yapılıyordu ve o alan GÖRÜNTÜ biriminde (BB), gönderilen tutar
             ise DEPOLAMA biriminde (mili-BB). 97.000 BB bakiyesi olan
             kullanıcı 20.000 BB göndermek isteyince 20.000.000 > 97.000
             çıkıp "Insufficient balance" alıyordu.
             `lcBalanceMilli` / `siteBalance` adları birimi taşıdığı için
             aynı hata bir daha sessizce yapılamaz. */
          siteBalance, lcBalanceMilli } = useAuth();
  /* Eski 'crypto' sekmesine yönlendiren çağrılar bozulmasın:
     initialTab='crypto' → Deposit sekmesi + Crypto yöntemi. */
  const [activeTab, setActiveTab] = useState(initialTab === 'crypto' ? 'deposit' : initialTab);
  const [loading, setLoading] = useState(false);

  // ÖDEME YÖNTEMİ (ray) — sekmeden bağımsız
  const [depositMethod, setDepositMethod] = useState(initialTab === 'crypto' ? 'crypto' : 'site');
  const [withdrawMethod, setWithdrawMethod] = useState('site');
  // 🪙 CÜZDAN-ÖNCE AKIŞ: null iken seçim ekranı, seçilince yöntem ekranı.
  // ⚠️ Yöntem durumu ('site'/'crypto') KORUNUYOR — tüm mevcut akışlar
  // (Gamepass, kripto fatura, iade) ona bakıyor. Cüzdan seçimi yalnızca
  // onu türetiyor: main→site, lc→crypto. Böylece navigasyon değişirken
  // para akışlarının tek satırı bile bozulmuyor.
  const [depWallet, setDepWallet] = useState(initialTab === 'crypto' ? 'lc' : null);
  const [wdWallet, setWdWallet] = useState(null);
  const pickDep = (w) => { setDepWallet(w); setDepositMethod(w === 'lc' ? 'crypto' : 'site'); };
  const pickWd  = (w) => { setWdWallet(w);  setWithdrawMethod(w === 'lc' ? 'crypto' : 'site'); };

  // TİP STATE'LERİ
  const [tipUsername, setTipUsername] = useState('');
  const [tipAmount, setTipAmount] = useState('');
  /* ⚠️ CÜZDAN DEĞİŞİNCE TUTAR KUTUSU TEMİZLENİR.
     Kutuda "23000" varken site→BB'ye geçilirse aynı rakam artık bambaşka
     bir değer demektir (23.000 site parası ≠ 23.000 BB). Rakamı olduğu
     gibi bırakmak, kullanıcının farkında olmadan yanlış tutar
     göndermesine yol açar. */
  useEffect(() => { setTipAmount(''); }, [wallet]);

  /* 💠 MM2 RAY AYARLARI (kur, sınırlar, durdurma bayrağı).
     ⚠️ TEK YERDEN OKUNUP PANELLERE GEÇİLİYOR. İki panel ayrı ayrı
     çekseydi, cüzdan sekmeleri arasında gezinen kullanıcı için aynı
     istek defalarca tekrarlanırdı. Ayrıca ikisi farklı anlarda
     tazelenip FARKLI kur gösterebilirdi — biri "1000 alırsın" derken
     diğeri başka rakam yazardı.
     ⚠️ Hata durumunda null kalır; paneller o zaman kendi güvenli
     varsayılanlarına düşüyor (kur "—", sınır 4). */
  const [mm2Cfg, setMm2Cfg] = useState(null);
  useEffect(() => {
    if (!isOpen) return undefined;
    let alive = true;
    (async () => {
      try {
        const r = await axios.get(`${API}/game/mm2/config`);
        if (alive) setMm2Cfg(r.data || null);
      } catch { if (alive) setMm2Cfg(null); }
    })();
    return () => { alive = false; };
  }, [isOpen]);

  // PROMO STATE'İ
  const [promoCode, setPromoCode] = useState('');


  // Modal açıldığında sekmeyi ayarla (Header'dan initialTab gelir)
  useEffect(() => {
    if (!isOpen) return;
    setActiveTab(initialTab === 'crypto' ? 'deposit' : initialTab);
    if (initialTab === 'crypto') setDepositMethod('crypto');
    // 🪙 Adımları sıfırla: modal her açılışta seçim ekranından başlasın.
    // ⚠️ initialTab='crypto' ile açılan çağrılar (ör. "kripto ile yatır"
    // kısayolu) doğrudan BB Coin akışına düşer, kullanıcı iki kez seçmez.
    setDepWallet(initialTab === 'crypto' ? 'lc' : null);
    setWdWallet(null);
  }, [isOpen, initialTab]);

  /* ⚠️ AÇIK KRİPTO FATURASI OLAN KULLANICIYI KENDİ EKRANINA GÖTÜR.
     Yöntem seçici varsayılan olarak "Roblox"ta duruyor. Kripto gönderip
     sayfayı kapatan kullanıcı geri döndüğünde aktif takas ekranını görür ve
     ödeme adresini bir daha ASLA bulamaz — para zincirde, kullanıcı
     ekranda kayıp. Açık fatura varsa rayı otomatik olarak kriptoya
     çeviriyoruz. Uç yoksa (arka uç henüz taşınmadıysa) sessizce geçilir. */
  useEffect(() => {
    if (!isOpen || !token) return;
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/game/crypto/deposit/active`,
          { headers: { Authorization: `Bearer ${token}` } });
        if (alive && data?.has_active) setDepositMethod('crypto');
      } catch { /* kripto katmanı yoksa yok say */ }
    })();
    return () => { alive = false; };
  }, [isOpen, token]);

  // ========================== İŞLEM FONKSİYONLARI ==========================

  const handleTip = async () => {
    /* ⚠️ ÇEVRİM CÜZDANA GÖRE. Ham `parseAmount` göndermek BB tarafında
       tutarı 1000 kat küçültüyordu (bkz. tipAmountToUnits). */
    const finalAmount = tipAmountToUnits(tipAmount, isLc);
    if (!tipUsername.trim() || finalAmount <= 0) return toast.error('Please fill in valid information and amount');

    /* İSTEMCİ TARAFI SINIR KONTROLÜ — sunucudan gelen tabloyla.
       ⚠️ Sunucuyu DEĞİL, kullanıcıyı korur: sunucu zaten reddediyor ama
       hata mesajı sunucunun birimiyle geliyordu ("100 BB – 100.000 BB")
       ve kullanıcı doğru rakamı yazdığını sandığı için ne yapacağını
       anlamıyordu. Burada aynı birimde, gönderMEDEN önce söylüyoruz.
       ⚠️ Sunucudaki kontrolün YERİNE GEÇMEZ; istemci kontrolü atlatılabilir. */
    const lim = walletMeta?.limits?.[wallet];
    if (lim) {
      const lo = Number(lim.tip_min), hi = Number(lim.tip_max);
      if (Number.isFinite(lo) && finalAmount < lo) {
        return toast.error(
          `Minimum tip is ${isLc ? `${fmtLcCeil(lo)} ${LC_CUR_CHIP}` : fmtMoney(lo)}.`);
      }
      if (Number.isFinite(hi) && finalAmount > hi) {
        return toast.error(
          `Maximum tip is ${isLc ? `${fmtLc(hi)} ${LC_CUR_CHIP}` : fmtMoney(hi)}.`);
      }
    }
    /* Bakiye kontrolü de gönderMEDEN önce: sunucu "Insufficient balance"
       diyor ama kullanıcı hangi cüzdanda eksik olduğunu göremiyordu.
       ⚠️ `activeBalance` KULLANILMAZ: o alan görüntü biriminde (BB) gelir,
       `finalAmount` ise depolama biriminde (mili-BB). İkisini kıyaslamak
       1000 katlık bir sapma üretir ve dürüst kullanıcıyı engeller. */
    /* Karşılaştırma DEPOLAMA biriminde: `finalAmount` de o birimde. */
    const bal = Number(isLc ? lcBalanceMilli : siteBalance);
    if (Number.isFinite(bal) && finalAmount > bal) {
      return toast.error(
        `Not enough ${isLc ? LC_CUR : SITE_CUR}. You have `
        + `${isLc ? `${fmtLc(bal)} ${LC_CUR_CHIP}` : fmtMoney(bal)}.`);
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/game/tip`, {
        target_username: tipUsername.trim(),
        amount: finalAmount
      }, { headers: { Authorization: `Bearer ${token}` } });

      toast.success(response.data.message);
      setTipUsername('');
      setTipAmount('');
    } catch (error) {
      const detail = error.response?.data?.detail;
      // Deposit-history kapısı: hesap hiç deposit yapmadıysa backend 403 + açıklama döner.
      toast.error(typeof detail === 'string' ? detail : 'Transfer failed');
    } finally { setLoading(false); }
  };

  const handlePromo = async () => {
    if (!promoCode.trim()) return toast.error('Please enter the promo code');

    setLoading(true);
    try {
      const response = await axios.post(`${API}/game/promo`, {
        code: promoCode.trim()
      }, { headers: { Authorization: `Bearer ${token}` } });

      toast.success(response.data.message);
      setPromoCode('');
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Promo code is invalid');
    } finally { setLoading(false); }
  };

  /* ══════════════════════════════════════════════════════════════
     ROBUX RAYLARININ LİMİTLERİ

     Kripto paneli sınırlarını tek bir yerden okuyor; MM2 tarafı
     okumuyordu ve bu yüzden ÇEKİMDE ÜST SINIR HİÇ YOKTU: kullanıcı
     bakiyesinin katı bir tutar yazıp butona basabiliyor, hatayı ancak
     sunucudan öğreniyordu. Aynı deseni buraya da getiriyoruz.
     ══════════════════════════════════════════════════════════════ */
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm overflow-y-auto" onClick={onClose}>
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            /* ⚠️ max-w-md (28rem) DARDI. Kurulum sihirbazı ve karar ekranı
               dikey olarak uzuyor, modal ekrandan taşıyor ve sayfanın kendisi
               kayıyordu — başlık görüş alanından çıkıyor, kullanıcı nerede
               olduğunu kaybediyordu.
               İki değişiklik: (1) geniş ekranda daha ferah bir genişlik, böylece
               aynı içerik daha az satıra sığıyor; (2) yüksekliği ekranla
               sınırlayıp kaydırmayı MODALIN İÇİNE alıyoruz, sayfa değil. */
            className="mm-chroma-edge w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-[#121417] rounded-[18px] border border-[#2A2D31] relative mt-10 md:mt-0 max-h-[92vh] flex flex-col overflow-hidden"
            style={{ boxShadow: '0 40px 90px -30px rgba(0,0,0,.95)' }}
            onClick={e => e.stopPropagation()}
          >
            {/* ══════════════════════════════════════════════════════════════
                ÜST ÇUBUK — SEKMELER + KAPAT, TEK SATIR
                ══════════════════════════════════════════════════════════════
                ⚠️ AYRI BAŞLIK BLOĞU KALDIRILDI. Üstte "Wallet" etiketi ve
                altında aktif sekmenin adını 22px ile tekrar yazan bir h2
                vardı. O h2 hiçbir şey eklemiyordu: hemen altındaki sekme
                rayı zaten aktif olanı RENKLE gösteriyor, yani aynı bilgi
                iki kez, biri gereksiz yere büyük puntoyla. Bedeli ~72px
                dikey alandı ve bu, ekranı zaten dar olan bir modalda
                doğrudan mağaza ızgarasından ve form alanlarından çalınıyordu.

                ⚠️ CÜZDAN DEĞİŞTİRME DÜĞMELERİ DE BURADAN SÖKÜLDÜ (daha önce).
                Backend'in kripto ve MM2 uçları `active_wallet`'a HİÇ
                BAKMIYOR — hangi cüzdanda olursan ol diğerine yatırıp
                diğerinden çekebilirsin. Düğmeler olmayan bir zorunluluğu
                varmış gibi gösteriyordu. Bakiye kaybolmadı: her akış KENDİ
                cüzdanının bakiyesini kendi başlık satırında gösteriyor.

                ⚠️ KAPAT DÜĞMESİ SEKMELERİN İÇİNE DEĞİL, YANINA konuyor.
                Kaydırılabilir bir rayın içine konsaydı ray kayınca düğme de
                ekrandan çıkardı — pencereyi kapatamayan bir kullanıcı.
                ══════════════════════════════════════════════════════════════ */}
            <div className="flex items-center gap-2 px-3 py-3 border-b border-[#2A2D31]">
              <div className="flex-1 min-w-0 flex gap-1 overflow-x-auto scrollbar-none p-1 rounded-xl bg-[#121417] border border-[#1F2225]">

                {tabs.map((tab) => {
                  const Icon = tab.icon;
                  const on = activeTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      data-testid={`wallet-tab-${tab.id}`}
                      aria-current={on ? 'page' : undefined}
                      className={`mm-focus flex-1 whitespace-nowrap px-3 py-2 rounded-lg font-bold text-[12px]
                                  transition-colors flex items-center justify-center gap-1.5 ${
                        on ? TAB_COLORS[tab.id].active
                           : 'text-zinc-500 hover:text-zinc-200 hover:bg-white/[0.04]'
                      }`}
                    >
                      <Icon className="w-3.5 h-3.5 shrink-0" />
                      <span>{tab.label}</span>
                    </button>
                  );
                })}
              </div>

              <button onClick={onClose} aria-label="Close wallet"
                className="mm-focus w-9 h-9 shrink-0 grid place-items-center rounded-lg
                           text-zinc-500 hover:text-white hover:bg-white/[0.06] transition-colors">
                <X style={{ width: 18, height: 18 }} />
              </button>
            </div>

            {/* ⚠️ KAYDIRMA BURADA. Modalın yüksekliği ekranla sınırlı; içerik
                uzadığında sayfa değil BU alan kayıyor, böylece sekme çubuğu
                ve kapat düğmesi her zaman görünür kalıyor. */}
            <div className="mm-scroll px-5 py-5 overflow-y-auto flex-1 min-h-0">

              {/* ══════════ 1. DEPOSIT TAB ══════════ */}
              {activeTab === 'deposit' && (
                <motion.div key="deposit" initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-4">

                  {/* ══ ADIM 1: HANGİ BAKİYE? ══
                      ⚠️ Devam eden bir MM2 işlemi varken seçim GÖSTERİLMEZ:
                      o anda ray değiştirmek kullanıcıyı yarım kalmış bir
                      takasla baş başa bırakır. Panelin kendisi aktif işlemi
                      algılayıp o ekranı gösteriyor. */}
                  {!depWallet && (
                    <div className="space-y-3">
                      <p className="text-[11px] text-zinc-500">
                        Pick which balance to top up.
                      </p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <WalletPickCard id="main" title={SITE_CUR} mode="deposit"
                          subtitle="Trade MM2 items to our bot and get MM Coin instantly."
                          amount={`${fmtBal(user?.balance || 0)} ${SITE_CUR_CHIP}`}
                          footer="Top up" onClick={() => pickDep('main')} />
                        <WalletPickCard id="lc" title={LC_CUR} mode="deposit"
                          subtitle="Send crypto, get BB Coin. Withdraw it back to crypto anytime."
                          amount={`${fmtLc(user?.lc_balance_milli || 0)} ${LC_CUR_CHIP}`}
                          footer="Top up" onClick={() => pickDep('lc')} />
                      </div>
                      <ConvertShortcut root="deposit" onClick={() => setActiveTab('convert')} />
                    </div>
                  )}

                  {/* ══ ADIM 2: SEÇİLEN RAY ══
                      ⚠️ GERİ BUTONU ARTIK PANELİN İÇİNDE. Burada ayrı bir
                      satır olarak dururken panelin kendi başlığıyla arasında
                      iki bomboş satır kalıyordu — dar bir modalda bu, ekranın
                      beşte biri demek. Panel `onBack`'i alıp başlığının
                      soluna koyuyor: tek satır, dolu ve profesyonel.
                      ⚠️ Kripto paneli bu prop'u tanımıyor; onun için geri
                      butonu burada kalıyor. */}
                  {depWallet && (
                    depositMethod === 'crypto' ? (
                      <CryptoPanel mode="deposit" token={token}
                        balance={user?.lc_balance_milli || 0}
                        onBack={() => setDepWallet(null)}
                        onCredited={refreshUser} />
                    ) : (
                      <Mm2DepositPanel user={user} token={token} cfg={mm2Cfg}
                        onBack={() => setDepWallet(null)}
                        onDone={refreshUser} />
                    )
                  )}
                </motion.div>
              )}

              {activeTab === 'withdraw' && (
                <motion.div key="withdraw" initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-4">

                  {!wdWallet && (
                    <div className="space-y-3">
                      <p className="text-[11px] text-zinc-500">
                        Pick which balance to cash out.
                      </p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <WalletPickCard id="main" title={SITE_CUR} mode="withdraw"
                          subtitle="Spend MM Coin on real MM2 items from our bot stock."
                          amount={`${fmtBal(user?.balance || 0)} ${SITE_CUR_CHIP}`}
                          footer="Cash out" onClick={() => pickWd('main')} />
                        <WalletPickCard id="lc" title={LC_CUR} mode="withdraw"
                          subtitle="Send BB Coin to your own crypto wallet."
                          amount={`${fmtLc(user?.lc_balance_milli || 0)} ${LC_CUR_CHIP}`}
                          footer="Cash out" onClick={() => pickWd('lc')} />
                      </div>
                      {/* ⚠️ KISAYOL ÇEKMEDE DE VAR. Çekmek isteyip yanlış
                          cüzdanda parası olan kullanıcı, dönüşümün var
                          olduğunu buradan öğreniyor. */}
                      <ConvertShortcut root="withdraw" onClick={() => setActiveTab('convert')} />
                    </div>
                  )}

                  {wdWallet && (
                    withdrawMethod === 'crypto' ? (
                      <CryptoPanel mode="withdraw" token={token}
                        balance={user?.lc_balance_milli || 0}
                        onBack={() => setWdWallet(null)}
                        onCredited={refreshUser} />
                    ) : (
                      <Mm2WithdrawPanel user={user} token={token} cfg={mm2Cfg}
                        onBack={() => setWdWallet(null)}
                        onDone={refreshUser} />
                    )
                  )}
                </motion.div>
              )}

              {activeTab === 'convert' && (
                <motion.div key="convert" initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-4">
                  <ConvertPanel />
                </motion.div>
              )}

              {/* ══════════ 3. TIP TAB ══════════ */}
              {activeTab === 'tip' && (
                <motion.div key="tip" initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-4">
                  {/* ⚠️ LİMİTLER SABİT YAZILAMAZ: iki cüzdanın tip sınırları
                      farklı birimde (site 1–100.000, LC 100.000–10.000.000.000
                      mili-LC). Sunucudan gelen tabloyu kullanıyoruz; alınamazsa
                      metni hiç göstermiyoruz ki yanlış rakam yazmayalım. */}
                  {walletMeta?.limits?.[wallet] && (
                    <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-4 mb-2">
                      <p className="text-xs text-amber-300/80 leading-relaxed text-center">
                        Minimum tip <WalletValue amount={walletMeta.limits[wallet].tip_min} wallet={wallet} /> ·
                        Maximum <WalletValue amount={walletMeta.limits[wallet].tip_max} wallet={wallet} />
                      </p>
                      <p className="text-[10px] text-amber-300/50 text-center mt-1">
                        Sent from your {isLc ? LC_CUR : SITE_CUR}. The recipient receives it in the same wallet.
                      </p>
                    </div>
                  )}
                  <div className="space-y-2">
                    <label className="text-sm text-zinc-400">Recipient Username (Site Username)</label>
                    <input
                      type="text"
                      value={tipUsername}
                      onChange={e => setTipUsername(e.target.value)}
                      placeholder="Example: player123"
                      className="w-full p-4 bg-[#15171a] border border-[#2A2D31] rounded-xl text-white outline-none focus:border-amber-500 transition-colors"
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="text-sm text-zinc-400">
                      Amount to Send ({isLc ? `${LC_CUR_CHIP}, e.g. 100` : 'e.g. 50, 2.5k'})
                    </label>
                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-amber-500 font-bold text-xs">
                        {isLc ? LC_CUR_CHIP : '$'}
                      </span>
                      <input
                        type="text"
                        value={tipAmount}
                        /* ⚠️ Cüzdana göre: BB'de 3 ondalık anlamlı,
                           site parasında ondalık yok. Tek temizleyici
                           kullanmak BB'de yazılan haneleri siliyordu. */
                        onChange={e => setTipAmount(sanitizeTipInput(e.target.value, isLc))}
                        placeholder={isLc ? '100' : '50'}
                        className="w-full p-4 pl-8 bg-[#15171a] border border-[#2A2D31] rounded-xl text-white outline-none focus:border-amber-500 transition-colors"
                      />
                    </div>
                  </div>
                  <button
                    onClick={handleTip}
                    disabled={loading || !tipUsername.trim() || !tipAmount}
                    className="w-full py-4 mt-2 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 rounded-xl text-white font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {loading ? <Loader2 className="animate-spin w-5 h-5" /> : <><Send className="w-5 h-5" /> Send</>}
                  </button>
                </motion.div>
              )}

              {/* ══════════ 4. PROMO CODE TAB ══════════ */}
              {activeTab === 'promo' && (
                <motion.div key="promo" initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-4">
                  <div className="flex justify-center mb-6">
                    <motion.div
                      animate={{ rotate: [-12, -8, -12] }}
                      transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
                      className="w-24 h-24 bg-rose-500/10 rounded-full flex items-center justify-center border border-rose-500/20"
                    >
                      <Ticket className="w-12 h-12 text-rose-400" />
                    </motion.div>
                  </div>
                  <div className="space-y-2 text-center">
                    <label className="text-sm text-zinc-400">Enter the Promo Code</label>
                    <input
                      type="text"
                      value={promoCode}
                      onChange={e => setPromoCode(e.target.value.toUpperCase())}
                      placeholder="XXXX-XXXX-XXXX"
                      className="w-full p-4 bg-[#15171a] border border-[#2A2D31] rounded-xl text-white text-center mm-num font-bold tracking-widest outline-none focus:border-rose-500 transition-colors uppercase"
                    />
                  </div>
                  <button
                    onClick={handlePromo}
                    disabled={loading || !promoCode.trim()}
                    className="w-full py-4 mt-4 bg-gradient-to-r from-rose-600 to-rose-500 hover:from-rose-500 hover:to-rose-400 rounded-xl text-white font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-[0_0_20px_rgba(244,63,94,0.3)]"
                  >
                    {loading ? <Loader2 className="animate-spin mx-auto w-6 h-6" /> : "Use Code"}
                  </button>
                </motion.div>
              )}

            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export const WalletModal = (props) => {
  if (typeof document !== 'undefined') {
    return ReactDOM.createPortal(<ModalContent {...props} />, document.body);
  }
  return null;
};

export default WalletModal;